export default {
  notif: { title: "Уведомления", subtitle: "Кто, когда и что сделал", markAll: "Прочитать все", empty: "Уведомлений нет", seeAll: "Показать все", loadError: "Ошибка загрузки" },
  common: { selectPlaceholder: "Выберите...", searchPlaceholder: "Поиск...", noResults: "Ничего не найдено" },
  proc: {
    title: "Мои процессы", subtitle: "Процессы, которые нужно выполнить",
    countSuffix: "процессов", logout: "Выйти", refresh: "Обновить",
    saved: "Сохранено", loadError: "Ошибка загрузки",
    problemTitle: "В чём проблема?", problemPlaceholder: "Кратко опишите проблему…", problemSubmit: "Отправить", problemRequired: "Опишите проблему", cancel: "Отмена",
  },

  snab: {
    title: "Мои заявки", subtitle: "Документы, которые нужно привезти",
    createReceipt: "Создать приход", tabProducts: "Товары", tabSuppliers: "Поставщики", suppliersEmpty: "Поставщиков нет", needQty: "Нужно", buy: "Купить", zoom: "Увеличить", tabRequests: "Заявка на деньги", needBy: "Срок:", noItems: "Нет позиций",
    logout: "Выйти", refresh: "Обновить", loadError: "Ошибка загрузки",
  },

  roles: {
    title: "Роли", subtitle: "Кастомные роли — управление видимостью модулей, действиями и данными",
    addRole: "Добавить роль", editRole: "Редактировать роль", name: "Название роли", namePlaceholder: "Например: Продавец, Кладовщик...", nameRequired: "Название роли обязательно",
    modulesSection: "Модули и действия", module: "Модуль", actionView: "Прос", actionCreate: "Доб", actionEdit: "Ред", actionDelete: "Уд",
    dataFlagsSection: "Скрываемые данные", dataFlagsHint: "Отмеченные данные скрываются для этой роли (телефон, email, сумма сделки...)",
    ownSection: "Показывать только свои", ownHint: "В отмеченных разделах пользователь видит только созданные им документы (не чужие).",
    save: "Сохранить", cancel: "Отмена", delete: "Удалить", deleteTitle: "Удалить роль", deleteText: "роль будет удалена. Пользователи этой роли вернутся к полному доступу.",
    added: "Роль добавлена", updated: "Роль обновлена", deleted: "Роль удалена", loadError: "Ошибка загрузки", genericError: "Произошла ошибка",
    empty: "Ролей нет", modulesCount: "модулей", hiddenCount: "скрыто",
    restricted: "Эти данные вам недоступны",
    prodSubActionsLabel: "Производство: отдельные права ввода",
    prodEditOutputs: "Ввод партий готовой продукции",
    prodEditComponents: "Ввод расхода сырья",
    flags: {
      contacts_phone: "Телефон контакта", contacts_email: "Email контакта", deals_value: "Сумма сделки",
      products_costPrice: "Себестоимость (цена закупки)", products_avgCost: "Средняя себестоимость", products_margin: "Маржа / наценка", inventory_stockValue: "Стоимость остатка",
      sklad_valuation: "Стоимость склада (общая себест.)", sklad_unitCost: "Себестоимость единицы",
      finance_pnl: "Прибыль и убыток (P&L)", finance_companyBalance: "Баланс предприятия", finance_cashboxBalance: "Балансы касс", finance_netProfit: "Чистая прибыль", finance_cogs: "Себестоимость (COGS)", finance_debtsTotals: "Суммы задолженности",
      cashbox_balance: "Баланс кассы", cashbox_turnover: "Оборот кассы",
      jobOrder_summary: "Суммы заказа (статистика + согласовано/оплачено/долг)", jobOrder_profit: "Прибыль заказа", jobOrder_totalCost: "Себестоимость заказа", jobOrder_laborCost: "Затраты на оплату труда", jobOrder_materialCost: "Затраты на материалы",
      jobOrder_lockBasic: "Запретить изменение основных данных", jobOrder_lockProcesses: "Запретить изменение процессов", jobOrder_lockMaterials: "Запретить изменение расходов", jobOrder_lockFiles: "Запретить изменение файлов", jobOrder_lockDelete: "Запретить удаление заказа",
      jobOrder_otherExpenses: "Скрыть раздел прочих расходов", jobOrder_otherExpensesEdit: "Запретить добавление прочих расходов", jobOrder_otherExpensesDelete: "Запретить удаление прочих расходов",
      jobOrder_lockConfirm: "Запретить подтверждение заказа", jobOrder_lockStart: "Запретить перевод в работу", jobOrder_lockComplete: "Запретить завершение заказа",
      proposal_cost: "Себестоимость предложения", proposal_margin: "Маржа предложения",
      reports_inventoryValue: "Отчёт: стоимость склада", reports_profitColumns: "Отчёт: столбцы прибыли",
    },
  },

  dtp: { now: "Сейчас", done: "Готово" },
  picker: { placeholder: "Товар...", search: "Поиск...", notFound: "Не найдено" },
  catPicker: { all: "Все", back: "Назад", empty: "Пусто", count: "{n} шт" },
  update: { title: "Доступна новая версия", subtitle: "Обновите страницу", action: "Обновить", dismiss: "Закрыть" },


  production: {
    loadError: "Ошибка загрузки", error: "Ошибка", cancel: "Отмена", save: "Сохранить", saved: "Обновлено", added: "Добавлено", deleted: "Удалено", movedToTrash: "Перемещено в корзину", toTrash: "В корзину", delete: "Удалить", back: "Назад", selectPlaceholder: "Выберите...", row: "Строка", addRow: "Добавить строку", print: "Печать", printTitle: "Печать", unitSuffix: "шт",
    prodLabel: "Производство", prodSubtitle: "Из сырья — готовая продукция", pkgLabel: "Упаковка", pkgSubtitle: "Упаковка готовой продукции",
    searchPlaceholder: "Номер или товар...", new: "Новый", notFound: "Документ не найден", notFoundHint: "Создайте новый документ", newBlank: "Создать пустой", newFromRecipe: "По рецепту", recipe: "Рецепт", norma: "Норма (сколько раз)", normaHint: "Рецепт умножается на это число (1 норма = 1 рецепт) — сырьё и выход записываются соответственно.", noRecipes: "Нет рецептов. Сначала добавьте в разделе Рецепты (BOM).", recipePickFirst: "Выберите рецепт",
    thNumber: "Номер", thDate: "Дата", thOutput: "Готовая продукция", thOut: "Выход", thCost: "Себестоимость", thUnit: "Единица", thStatus: "Статус", thActions: "Действия", outLabel: "Выход:",
    trashTitle: "Перемещение в корзину", trashText1: "документ будет перемещён в корзину. Остаток сырья и готовой продукции вернётся (можно восстановить в течение 30 дней).",
    docLoadError: "Документ не загружен", bomSelectProductFirst: "Сначала выберите готовую продукцию", bomQtyFirst: "Введите количество выхода", bomNotFound: "Для этого товара рецепт не найден", bomLoaded: "Рецепт загружен", whRequired: "Нужно выбрать склады", outProductRequired: "Нужно выбрать готовую продукцию", outQtyInvalid: "Неверное количество выхода", minOneComponent: "Введите хотя бы одно сырьё", costShare: "Доля стоимости", costShareAuto: "авто", costShareHint: "Если доля не указана — общая стоимость распределяется автоматически по количеству выхода. Если указать доли — пропорционально этим весам.", outAllocCost: "Стоимость", outputsCount: "продукта", removeRow: "Удалить строку", lotLabel: "Партия:", lotCol: "Партия", lotAuto: "Авто (самая старая)", lotNoLabel: "Без партии", lotLeft: "остаток", uomRequired: "Выберите единицу измерения", compProductRequired: "Выберите сырьё", compQtyRequired: "Введите количество сырья", colCashbox: "Касса (нал.)", overheadNoCash: "— (только в себестоимость)", overheadCashHint: "Если выбрана касса — расход списывается наличными из неё и виден в карточке кассы. В себестоимость входит всё равно; в Платежи/P&L отдельно не пишется (без двойного счёта).", addGroup: "Группа", newGroup: "Новая группа", groupNamePlaceholder: "Название группы", removeGroup: "Удалить группу", moveTo: "Переместить", moveToUngrouped: "Без группы", addBatch: "Добавить партию", batchTime: "Время", batchTotal: "Итого", grandTotalLabel: "Всего готовой продукции:", normaTitle: "Норма", normaPerUnit: "сырья на", normaAdd: "Добавить сырьё",
    componentsTitle: "Сырьё (расход)", noComponents: "Нет строк сырья", colProduct: "Товар", colQty: "Количество", colUom: "Единица", colEstCost: "Прибл. себест.", uomPlaceholder2: "единица", costInline: "Себест.:", stockInStock: "Склад:",
    costTitle: "Себестоимость (примерно)", costMaterials: "Сырьё", costOverhead: "Доп. расходы", costTotal: "Итого себестоимость", costUnit: "Себест. единицы", costNote: "При сохранении фактическая себестоимость определяется методом FIFO/средней, и avgCost готовой продукции обновляется на этой основе.", note: "Комментарий", optional: "Необязательно...",
    trashText2: "Документ будет перемещён в корзину. Остаток сырья и готовой продукции вернётся (можно восстановить в течение 30 дней).",
    bomMahsulotRequired: "Нужно выбрать товар", bomMinOneComponent: "Хотя бы одна строка состава", bomOutQtyInvalid: "Неверное количество выхода", bomEditTitle: "Редактировать рецепт", bomNewTitle: "Новый рецепт (BOM)", bomKind: "Тип", bomOutProduct: "Готовая продукция", bomOutQty: "Количество выхода", bomOutQtyHint: "Этот рецепт на указанное количество готовой продукции", bomUom: "Единица", bomComponents: "Сырьё", bomNoRows: "Нет строк", bomColUom: "Единица", bomColNote: "Комментарий", bomColCategory: "Категория", bomOverheadHint: "Если выбрать категорию, привяжется к категории расхода в Платежах (в отчётах отображается объединённо).",
    bomTitle: "Рецепты (BOM)", bomNavShort: "Рецепты", recipeSaveBtn: "Сохранить рецепт", recipeSaveTitle: "Сохранить текущую форму как рецепт", recipeSaveHint: "Текущие готовая продукция, сырьё и расходы сохранятся как рецепт. Потом 'По рецепту' + норма автоматически заполнит эти данные.", recipeName: "Название рецепта", recipeNamePlaceholder: "Например: Хлеб (стандарт)", recipeNameRequired: "Введите название рецепта", recipeSaved: "Рецепт сохранён", bomSubtitle: "Рецепты сырья для готовой продукции", all: "Все", bomSearchPlaceholder: "Товар...", bomNewBtn: "Рецепт", bomEmpty: "Нет рецептов", bomThProduct: "Товар", bomThKind: "Тип", bomThOut: "Выход", bomThComposition: "Состав", bomThOverhead: "Доп.рас.", componentsCount: "видов сырья", overheadShort: "Доп.рас.:", bomDeleteTitle: "Удалить рецепт", bomDeleteText: "рецепт будет полностью удалён.",
  },

  scheduled: {
    title: "Обязательные платежи", subtitle: "Шаблоны платежей, которые нужно оплачивать каждый месяц.",
    new: "Новый платёж", add: "Добавить", edit: "Изменить", delete: "Удалить",
    name: "Название", namePlaceholder: "Аренда офиса, Электричество...",
    amount: "Сумма", dayOfMonth: "Число месяца", dayHint: "(1–28)",
    cashbox: "Касса", category: "Категория", counterparty: "Контрагент", note: "Примечание",
    optional: "необязательно",
    statusPaid: "Оплачено", statusPending: "Ожидает", statusOverdue: "Просрочено",
    lastPaid: "Последняя оплата",
    payBtn: "Создать расход", payTitle: "Создать платёж", payDate: "Дата", payConfirm: "Создать платёж",
    paySuccess: "Платёж создан", payError: "Произошла ошибка",
    deleteConfirm: "Удалить шаблон?", deleted: "Удалено",
    saved: "Сохранено", loadError: "Ошибка загрузки",
    empty: "Нет обязательных платежей", emptyHint: "Добавьте ежемесячные расходы",
    active: "Активен", inactive: "Неактивен", toggleActive: "Изменить статус",
    every: "Каждого", dayLabel: "-го числа",
    totalMonth: "Всего обязательных платежей", totalPaid: "Оплачено", totalRemain: "Остаток",
    itemsCount: "шт",
  },
  payReq: {
    title: "Заявки", subtitle: "Денежные заявки сотрудников.", new: "Заявка", newTitle: "Новая заявка",
    send: "Отправить", sent: "Заявка отправлена", cancel: "Отмена", amount: "Сумма", amountInvalid: "Неверная сумма",
    note: "Примечание", notePlaceholder: "Для чего нужно...", paymentMethod: "Форма оплаты", paymentMethodPlaceholder: "Наличные / Карта / Перечисление...", pmCash: "Наличные", pmCard: "Карта", pmTransfer: "Перечисление", jobOrder: "Заказ", optional: "необязательно", searchPlaceholder: "Номер или клиент...", notFound: "Не найдено", noteRequired: "Примечание обязательно",
    loadError: "Ошибка загрузки", error: "Ошибка", empty: "Заявок нет", emptyHint: "Добавьте новую заявку",
    byFinance: "Финансы:", reason: "Причина:", approve: "Подтвердить", approved: "Подтверждено", markPaid: "Оплачено", approveTitle: "Подтвердить заявку", approveHint: "Укажите разрешённую сумму. Это ещё не оплата.", approvedAmount: "Утверждённая сумма", requested: "Запрошено", statTotal: "Всего заявок", statApproved: "Утверждено", statPaid: "Выдано", statRejected: "Отклонено", reject: "Отклонить",
    rejectTitle: "Отклонить заявку", rejectReasonLabel: "Причина отклонения (необязательно):", rejectReasonPlaceholder: "Причина...",
    rejected: "Отклонено", delete: "Удалить", deleteConfirm: "Удалить заявку?", deleted: "Удалено",
    tabs: { pending: "В ожидании", approved: "Подтверждено", paid: "Оплачено", rejected: "Отклонено", all: "Все" },
    status: { pending: "В ожидании", approved: "Подтверждено", paid: "Оплачено", rejected: "Отклонено" },
  },
  integrations: { back: "Назад",
    title: "Интеграции", subtitle: "Подключайте интеграции с другими сервисами.",
    saved: "Сохранено", error: "Ошибка", on: "Включено", enable: "Включить", disable: "Выключить", activeSuffix: "активно", off: "Выключено", soon: "Скоро", configure: "Настроить", eskizConn: "Подключение", eskizOk: "Подключено", eskizEmail: "Email", eskizPassword: "Пароль", eskizPassKeep: "Оставьте пустым, чтобы не менять", eskizFrom: "Отправитель (nick)", eskizFromHint: "Для теста 4546. Реальный ник подтверждается в Eskiz.", eskizSave: "Сохранить и подключить", eskizTest: "Тест SMS", eskizPhone: "Телефон", eskizMessage: "Сообщение", eskizSendTest: "Отправить тест", eskizTestHint: "Стандартный текст «Это тест от Eskiz» одобрен. Свой текст добавьте на модерацию: my.eskiz.uz → СМС → Мои тексты.", eskizEmailReq: "Введите email", eskizPhoneReq: "Введите номер телефона", eskizConnected: "Eskiz подключён", eskizSent: "SMS отправлено", smsRulesTitle: "SMS-уведомления", smsRulesHint: "При событии клиенту автоматически отправляется SMS (текст должен быть одобрен в Eskiz).", smsPlaceholders: "Подстановки", smsTplPlaceholder: "Например: Уважаемый {customer}, заказ {number} принят.", smsRulesSave: "Сохранить уведомления", tabSettings: "Настройки", tabHistory: "История", balTitle: "Баланс SMS", balTotal: "Общий баланс", balPrice: "Цена 1 SMS", balSave: "Сохранить баланс", balLow: "Мало баланса!", balLowHint: "Баланс меньше цены одного SMS. Пополните.", histEmpty: "SMS ещё не отправлялись", evtJoCreated: "При создании заказа (job order)", evtJoDelivered: "При завершении заказа (job order)", evtSaleCreated: "При создании продажи (накладная)", evtPayIncoming: "При получении оплаты",
    cat: { sms: "SMS", hr: "HR" },
    svc: { "hr-line": "Управление персоналом (HR Line)", "sms-eskiz": "Отправка SMS (eskiz.uz)", "sms-playmobile": "SMS-шлюз (Play Mobile)", "hr-attendance": "Учёт посещаемости", "hr-payroll": "Расчёт зарплаты" },
  },
  finance: { total: "Итого", debtsTitle: "Долги", debtsSubtitle: "Дебиторы и кредиторы (баланс контрагентов)", none: "Нет", debtors: "Дебиторы", debtorsHint: "Должны нам", creditors: "Кредиторы", creditorsHint: "Мы должны", pfDocLoadError: "Документ не загружен", pfCpRequired: "Нужно выбрать контрагента", pfCashboxRequired: "Нужно выбрать кассу", pfAmountInvalid: "Неверная сумма", pfDateInvalid: "Неверная дата (DD/MM/YYYY HH:MM)", pfHeaderTitle: "Платежи", pfFromRequest: "Этот расход создаётся на основе заявки:", pfPrint: "Печать", pfPrintTitle: "Печать", pfAddAnother: "Добавить ещё приход", pfAddAnotherTitle: "Добавить ещё приход для этого заказа (из другой кассы)", pfJoRemainTitle: "По заказу есть остаток долга", pfJoRemainHint: "Платёж сохранён. Если клиент хочет оплатить и в другую кассу, нажмите «Добавить ещё приход».", pfDateLabel: "Дата:", pfStatusless: "Без статуса", pfCpLabel: "Контрагент *", pfNewCpTitle: "Добавить контрагента", pfCashboxLabel: "Касса *", pfCashboxSelect: "Выберите кассу...", pfBalance: "Баланс:", pfAmountLabel: "Сумма *", pfCategoryLabel: "Категория", pfManage: "Управление", pfCategoryless: "Без категории", pfJobOrder: "Заказ", pfJobOrderHint: "Если выбрать, платёж привяжется к балансу этого заказа. Пусто — обычный приход.", pfProcess: "Процесс (труд)", pfProcessHint: "Сумма платежа запишется в труд этого процесса.", pfProcessRequired: "Нужно выбрать процесс", pfProcessCurrencyMismatch: "Валюта платежа должна совпадать с валютой заказа", pfOptional: "необязательно", pfNote: "Примечание", pfNotePlaceholder: "Примечание (необязательно)...", pfJoTotal: "Сумма заказа", pfJoPaid: "Оплачено", pfJoRemaining: "Остаток", pfJoHistory: "История платежей", pfJoNoPayments: "Платежей пока нет", pfJoLoading: "Загрузка...", pfDeleteText: "Платёж будет удалён, баланс контрагента восстановлен.", pfNameLabel: "Название *", pfNamePlaceholder: "Название", pfCommissionAdd: "Добавить комиссию", pfCommission: "Комиссия (2-й расход)", pfCommissionPct: "Процент", pfSecondAdd: "Разделить на 2-ю кассу", pfSecondTitle: "Приход во 2-ю кассу (наличные + карта)", pfSecondCashboxLabel: "2-я касса", pfSecondAmountLabel: "Сумма 2-й кассы", pfSecondRemove: "Отмена", pfSecondCashboxRequired: "Нужно выбрать 2-ю кассу", pfSecondSameCashbox: "2-я касса должна отличаться", pfSecondInvalid: "Неверная сумма 2-й кассы", pfCommissionInvalid: "Неверная сумма комиссии", pfCommissionEmpty: "Категории комиссии не заданы — выберите через «Управление».", pfCommissionMgrTitle: "Категории комиссии", pfCommissionMgrHint: "Отмеченные категории расхода доступны для выбора в комиссии.",
    loadError: "Ошибка загрузки", cancel: "Отмена", save: "Сохранить", add: "Добавить", saved: "Обновлено", added: "Добавлено", deleted: "Удалено", error: "Ошибка", delete: "Удалить", deleteTitle: "Подтвердите удаление", nameRequired: "Название обязательно", search: "Поиск...", notFound: "Не найдено", selectCp: "Выберите контрагента...", loadMore: "Загрузить ещё", clearSelection: "Очистить выбор", edit: "Редактирование", back: "Назад", kirim: "Приход", chiqim: "Расход", insufficient: "Недостаточно средств в кассе",
    thName: "Название", thCurrency: "Валюта", thBranch: "Филиал", thBalance: "Баланс", thActions: "Действия", thNumber: "Номер", thDate: "Дата", thType: "Тип", thCp: "Контрагент", thCashbox: "Касса", thCategory: "Категория", thAmount: "Сумма", thStatus: "Статус", thDesc: "Описание", thDirection: "Направление",
    cbReportLoadError: "Ошибка загрузки отчёта", cbBase: "Основная", cbTitle: "Баланс предприятия", cbSubtitle: "Чистая стоимость по каждой валюте (net worth)", noData: "Нет данных", cbGrandTotal: "Общая чистая стоимость (в пересчёте на {base})", cbConvertedNote: "Другие валюты рассчитаны по курсам организации", cbRatesLabel: "Курс", cbInventory: "Складские остатки (себестоимость)", cbInventoryHint: "Сырьё и готовая продукция", cbReceivables: "Дебиторская задолженность", cbReceivablesHint: "Деньги, которые заплатят контрагенты", cbCash: "Деньги в кассах", cbCashHint: "Кассы в этой валюте", cbPayables: "Долг перед контрагентами", cbPayablesHint: "Долг, который нужно выплатить контрагентам", cbFormula: "Формула: Себестоимость склада + Дебиторская задолженность + Деньги в кассах − Долг перед контрагентами. Себестоимость склада хранится только в основной валюте ({base}).",
    pnlTitle: "P&L (Прибыль и убыток)", pnlSubtitle: "Выручка → Себестоимость → Валовая прибыль → Расходы → Чистая прибыль (в основной валюте)", pnlReport: "P&L отчёт", pnlRevenue: "Выручка (продажи)", pnlCogs: "− Себестоимость", pnlGross: "= Валовая прибыль", pnlOpex: "− Операционные расходы", pnlOperating: "= Операционная прибыль", pnlFinancial: "− Финансовые расходы (проценты/банк)", pnlSecLabel: "Раздел P&L", pnlSecHint: "Операционные — обычные расходы; Финансовые — проценты/кредиты; Исключено — оплата поставщику/долг.", pnlSec_operating: "Операционные", pnlSec_financial: "Финансовые", pnlSec_excluded: "Исключено", pnlNet: "≡ Чистая прибыль", pnlNote: "Примечание: Себестоимость на основе текущей себестоимости (примерно). Налоги и кредиты не учитываются.", pnlExpenseDetail: "Детализация операционных расходов", pnlNoExpense: "Нет расходных платежей", pnlCashFlow: "Денежный поток (дополнительно)", pnlCashFlowHint: "Движение по кассе, не влияет на P&L", pnlNetFlow: "Чистый поток",
    cbxCurrencyRequired: "Нужно выбрать валюту", cbxEditTitle: "Редактировать кассу", cbxNewTitle: "Новая касса", cbxNameLabel: "Название *", cbxNamePlaceholder: "Название кассы", cbxCurrencyLabel: "Валюта *", cbxBranchLabel: "Филиал", cbxBranchNone: "— Не выбрано —", cbxBranchHint: "Филиалы добавляются в разделе Настройки → Предприятие.", cbxTitle: "Кассы", cbxSubtitle: "Список касс", cbxAdd: "Добавить кассу", cbxNotFound: "Касса не найдена", cbxNotFoundHint: "Добавьте новую кассу", cbxDeleteText: "касса будет удалена.",
    ccTitle: "Карточка кассы", ccNotFound: "Касса не найдена", ccBackToList: "Назад к списку", ccConversion: "Конвертация", ccReceipt: "Наличный приход (закупка)", ccOverhead: "Производственный расход", ccConvOut: "(расход)", ccConvIn: "(приход)", ccCurrentBalance: "Текущий баланс", ccJournal: "Журнал движений", ccNoMovements: "Нет движений",
    convCashboxesRequired: "Нужно выбрать кассы", convSameCashbox: "Нельзя выбрать одну и ту же кассу", convSameCurrency: "Нельзя конвертировать в ту же валюту", convTransferMode: "Перемещение (без курса, 1:1)", convTransferTitle: "Перемещение между кассами", convTransferBtn: "Переместить", convTransferTag: "Перемещение", convFromAmountInvalid: "Неверная сумма к выдаче", convRateRequired: "Введите курс", convDone: "Конвертация выполнена", convEditTitle: "Редактировать конвертацию", convNewTitle: "Новая конвертация", convFrom: "Из кассы", convSelect: "Выберите...", convBalance: "Баланс:", convGive: "Выдаётся (сумма)", convTo: "В кассу", convRate: "Курс", convReverse: "Обратный", convReceive: "Получается", convAuto: "(автоматически)", convDoBtn: "Выполнить", convTitle: "Конвертация", convSubtitle: "Перевод валюты из кассы в кассу", convNewBtn: "Конвертация", convNotFound: "Конвертация не найдена", convNotFoundHint: "Создайте новую конвертацию", convThGive: "Выдаётся", convThReceive: "Получается", convDeleteText: "конвертация будет удалена. Балансы касс восстановятся.",
    payTitle: "Платежи", paySubtitle: "Приход и расход денег", paySearch: "Номер или контрагент...", payFilterCp: "Контрагент", payFilterCashbox: "Все кассы", payFilterCategory: "Все категории", payIncoming: "Приход денег", payOutgoing: "Расход денег", payNotFound: "Платёж не найден", payNotFoundHint: "Создайте приход или расход денег", payDeleteText: "платёж будет удалён. Баланс контрагента восстановится.",
    pfIncomingTitle: "Приходный платёж", pfOutgoingTitle: "Расходный платёж", pfJoSelect: "Выберите заказ...", pfClearSelection: "— Очистить выбор —", pfJoSearch: "Номер или клиент...", pfNewCp: "Новый контрагент", cpAdded: "Контрагент добавлен", pfPhone: "Телефон", pfPhonePlaceholder: "+998 ...", smTitle: "Управление статусами", smNew: "Новый статус", smNamePlaceholder: "Название статуса...", catIncomingTitle: "Категории прихода", catOutgoingTitle: "Категории расхода", catNew: "Новая категория", catNamePlaceholder: "Название категории...",
    ppIncomingTitle: "ПРИХОДНЫЙ ОРДЕР", ppOutgoingTitle: "РАСХОДНЫЙ ОРДЕР", ppDate: "Дата:", ppReceivedFrom: "Принято (от кого)", ppGivenTo: "Выдано (кому)", ppCashbox: "Касса:", ppCategory: "Категория:", ppAmount: "Сумма:", ppNote: "Комментарий:", ppSignedIncomingLeft: "Сдал (подпись)", ppSignedOutgoingLeft: "Выдал (подпись)", ppSignedIncomingRight: "Принял (подпись)", ppSignedOutgoingRight: "Получил (подпись)",
  },

  contracts: { optional: "необязательно", legalNamePlaceholder: "Юридическое название", managerLabel: "Ответственный (кто ведёт)", managerNone: "Не выбран",
    selectCp: "Выберите контрагента...", search: "Поиск...", notFound: "Не найдено",
    editTitle: "Редактировать договор", newTitle: "Новый договор",
    number: "Номер", date: "Дата", cpLabel: "Контрагент *", legalName: "Юр. название", inn: "ИНН", legalMissing: "В карточке контрагента не заполнены юр. название/ИНН.", amount: "Сумма *", currency: "Валюта",
    description: "Описание", descPlaceholder: "Тема договора...", note: "Комментарий", notePlaceholder: "Необязательно...",
    filesLabel: "Файлы (PDF, сканы)", cancel: "Отмена", save: "Сохранить", add: "Добавить",
    cpRequired: "Нужно выбрать контрагента", amountInvalid: "Неверная сумма",
    saved: "Обновлено", added: "Добавлено", error: "Ошибка", loadError: "Ошибка загрузки", deleted: "Удалено",
    title: "Договоры", subtitle: "Реестр договоров — каждому договору присваивается номер автоматически",
    searchPlaceholder: "Номер, контрагент...", newBtn: "Договор", empty: "Нет договоров", emptyHint: "Добавьте новый договор",
    thCp: "Контрагент", thAmount: "Сумма", thCreatedBy: "Создал", thActions: "Действия",
    deleteTitle: "Подтвердите удаление", deleteText: "договор будет удалён.", delete: "Удалить",
  },

  aktSverka: { tabCustomer: "С клиентом", tabSupplier: "С поставщиком",
    selectCp: "Выберите контрагента...", search: "Поиск...", notFound: "Не найдено",
    cpRequired: "Нужно выбрать контрагента", error: "Ошибка", copied: "Скопировано",
    regenConfirm: "Старая ссылка будет аннулирована и создана новая. Продолжить?", urlUpdated: "Ссылка обновлена",
    title: "Акт сверки", subtitle: "Документ взаиморасчётов с контрагентом", cpLabel: "Контрагент",
    fromDate: "Дата начала", toDate: "Дата окончания", generate: "Сформировать", print: "Печать / PDF",
    permUrlTitle: "Постоянный URL для контрагента", permUrlHint: "Этот URL постоянный — контрагент может сохранить его и в любое время посмотреть свои взаиморасчёты. Периоды выбираются на публичной странице.",
    copyTitle: "Копировать", copy: "Копия", regenTitle: "Новый URL (старый аннулируется)", regen: "Обновить",
    loadError: "Ошибка загрузки", linkError: "Не удалось открыть ссылку", printShort: "Печать / PDF",
    docTitle: "АКТ СВЕРКИ", docSubtitle: "Взаиморасчёты между контрагентами", ourOrg: "Наша организация", tel: "Тел", period: "Период",
    noTx: "В этом периоде нет транзакций", currencyLabel: "Валюта", thDate: "Дата", thDoc: "Документ", thDebit: "Дебет", thCredit: "Кредит", thBalance: "Сальдо",
    openingBalance: "Начальное сальдо", totalRow: "Итого",
    theyOweA: " должен нам ", theyOweB: ".", weOwePre: "Мы должны ", weOweMid: " ", weOweSuf: ".",
    signOur: "Со стороны нашей организации:", signCp: "Со стороны контрагента:", signLine: "(ФИО, должность, подпись, дата)",
  },

  sklad: { allCategories: "Все категории", lowOnly: "Мало на складе", totalValue: "Общая стоимость остатка", thCategory: "Категория", thValue: "Стоимость",
    loadError: "Ошибка загрузки", cancel: "Отмена", save: "Сохранить", add: "Добавить", saved: "Обновлено", added: "Добавлено", deleted: "Удалено", error: "Ошибка", delete: "Удалить", deleteTitle: "Подтвердите удаление", nameRequired: "Название обязательно", total: "Итого", thName: "Название", thProduct: "Товар", thUom: "Ед.", sku: "SKU",
    sbTitle: "Остатки", sbSubtitle: "Остатки товаров по складам", sbSearch: "Поиск товара...", sbNotFound: "Товар не найден", sbNotFoundHint: "Остатки формируются через приходные документы",
    rTitle: "Общая себестоимость", rSubtitle: "Стоимость склада на основе остатков и себестоимости", rKpi: "Общая стоимость склада (себестоимость)", rEmpty: "Нет остатков", rStock: "Остаток", rCost: "Себестоимость", rValue: "Стоимость",
    tTitle: "Перемещения", tSubtitle: "Перемещение товаров между складами", tNew: "Перемещение", tSearch: "Поиск по номеру...", tNotFound: "Перемещения не найдены", tNotFoundHint: "Создайте новый документ перемещения", tNumber: "Номер", tDate: "Дата", tDirection: "Направление", tProducts: "Товары", itemCountSuffix: "товаров",
    whEditTitle: "Редактировать склад", whNewTitle: "Новый склад", whNameLabel: "Название *", whNamePlaceholder: "Название склада", whTitle: "Склады", whSubtitle: "Список складов", whAdd: "Добавить склад", whNotFound: "Склад не найден", whNotFoundHint: "Добавьте новый склад", thActions: "Действия", whDeleteText: "склад будет удалён.",
    lsTitle: "Товары на исходе", lsSubtitleSearch: "Найдите товар и задайте минимальный остаток", lsSubtitle: "Товары с остатком ниже заданного минимума", lsAlerts: "Оповещения", lsEmpty: "Нет товаров на исходе", lsEmptyHint: "Найдите товар, чтобы задать минимальный остаток", lsLow: "Мало", lsEnough: "Достаточно", lsCurrentStock: "Текущий остаток", lsMinStock: "Минимальный остаток", lsStatus: "Статус",
    tfNotFound: "Не найдено", tfCatalogEmpty: "Каталог пуст", tfTypeProduct: "Введите название товара...", tfDocLoadError: "Документ не загружен", tfFromRequired: "Нужно выбрать склад-источник", tfToRequired: "Нужно выбрать склад-получатель", tfSameWarehouse: "Нельзя выбрать один и тот же склад", tfDateInvalid: "Неверная дата (DD/MM/YYYY HH:MM)", tfMinOneProduct: "Введите хотя бы один товар", tfMoved: "Перемещено", back: "Назад", tfHeaderTitle: "Перемещение между складами", tfDocTitle: "Документ перемещения", tfFrom: "Откуда *", tfTo: "Куда *", tfSelectWarehouse: "Выберите склад...", tfThAvailFrom: "Доступно (откуда)", tfQty: "Количество", tfAvailable: "Доступно", tfNote: "Комментарий", tfNotePlaceholder: "Комментарий...", tfDeleteText: "документ перемещения будет удалён. Остатки вернутся.",
  },

  cpCard: { kind: { purchaseOrder: "Заказ на закупку", purchaseReceipt: "Приход", purchaseReturn: "Возврат закупки", salesOrder: "Заказ на продажу", salesInvoice: "Продажа", salesReturn: "Возврат продажи" }, loadError: "Ошибка загрузки", cardTitle: "Карточка контрагента", back: "Назад", notFound: "Контрагент не найден", backToList: "Вернуться к списку", debtTitle: "Задолженность",
    payIn: "Оплата (приход)", payOut: "Оплата (расход)", weOwe: "Мы должны", theyOwe: "Нам должны",
    tabs: { documents: "Документы", payments: "Оплаты", ledger: "История баланса", products: "Товары", prices: "Цены" },
    thKind: "Тип", thNumber: "Номер", thDate: "Дата", thStatus: "Статус", thSum: "Сумма", thCashbox: "Касса", thCategory: "Категория", thDoc: "Документ", thChange: "Изменение", thBalance: "Баланс",
    noDocuments: "Документов нет", noPayments: "Оплат нет", ledgerEmpty: "История баланса пуста",
  },

  counterparties: { thName: "Название", thPhone: "Телефон", thContacts: "Контакты", thDebt: "Задолженность", thActions: "Действия", contactsSuffix: "контакт", addBtn: "Добавить", statTotal: "Всего", statCustomers: "Клиенты", statSuppliers: "Поставщики",
    folderNamePlaceholder: "Название папки...", cancel: "Отмена", error: "Ошибка", subFolderTitle: "Добавить подпапку",
    folders: "Папки", statusMgrTitle: "Управление статусами", editLabel: "Редактирование", newStatus: "Новый статус",
    statusNamePlaceholder: "Название статуса...", save: "Сохранить", add: "Добавить",
    all: "Все", statusless: "Без статуса", status: "Статус",
    loadError: "Ошибка загрузки", saved: "Обновлено", added: "Добавлено", deleted: "Удалено",
    title: "Контрагенты", subtitle: "Клиенты и поставщики", allFolders: "Все папки", searchPlaceholder: "Поиск...",
    notFound: "Контрагенты не найдены", createHint: "Добавьте нового контрагента",
    weOwe: "Мы должны", theyOwe: "Нам должны",
    editTitle: "Редактирование", newTitle: "Добавить контрагента", nameLabel: "Название", namePlaceholder: "Название компании или ФИО",
    folderLabel: "Папка", noFolder: "Без папки", configure: "Настроить",
    phone: "Телефон", phonePlaceholder: "+998 90 000 00 00", email: "Email", emailPlaceholder: "example@mail.com", comment: "Комментарий", commentPlaceholder: "Примечание...",
    contactsTitle: "Контактные лица", addContact: "Добавить", noContacts: "Контакты не добавлены",
    cName: "Имя", cNamePlaceholder: "Имя Фамилия", cRole: "Должность", cRolePlaceholder: "Директор, Менеджер...", cPhone: "Номер",
    requisitesTitle: "Реквизиты", inn: "ИНН", innPlaceholder: "123456789",
    legalName: "Юр. название", legalNamePlaceholder: "ООО \"Компания\"", legalAddr: "Юр. адрес", legalAddrPlaceholder: "г. Ташкент, Чиланзарский р-н, ...",
    bankAccount: "Банковский счёт", bankPlaceholder: "2020 8000 0000 0000 0000", update: "Обновить",
    location: "Адрес / Местоположение", locationPlaceholder: "Город, улица, дом...",
    deleteTitle: "Подтвердите удаление", deleteText: "будет удалён.", delete: "Удалить",
  },

  uomNames: {
    pcs: "штука", kg: "килограмм", g: "грамм", t: "тонна", l: "литр", ml: "миллилитр",
    m: "метр", cm: "сантиметр", mm: "миллиметр", "m²": "квадратный метр", "m³": "кубометр", km: "километр",
    pair: "пара", roll: "рулон", box: "коробка", pack: "пачка", bag: "мешок", set: "комплект",
    bottle: "бутылка", can: "банка", cyl: "баллон", coil: "бухта", spool: "катушка", sheet: "лист", bunch: "связка",
    hr: "час", min: "минута", day: "день", week: "неделя", month: "месяц", year: "год",
    visit: "визит", session: "сеанс", project: "проект", page: "страница", word: "слово", trip: "рейс",
  },
  productForm: { images: "Изображения", imagesHint: "шт • первое — обложка", setCover: "Сделать обложкой", uploading: "Загрузка...", imageDrop: "Выберите изображение или перетащите сюда", imageError: "Ошибка загрузки изображения",
    variantsTitle: "Варианты", variantsHint: "Варианты по атрибутам: цвет, размер",
    attributesTitle: "Атрибуты", attrNamePlaceholder: "Название атрибута (напр. Цвет)", attrValuePlaceholder: "Добавить значение + Enter",
    addAttribute: "Добавить атрибут", generateVariants: "Создать варианты",
    variantsListTitle: "Варианты", totalStock: "Всего остаток", variantCol: "Вариант", imageCol: "Фото", skuCol: "Артикул", priceCol: "Цена", costCol: "Себест.", stockCol: "Остаток",
    stockHint: "Укажите начальный остаток по каждому варианту; остаток товара = сумма вариантов",
    ptTitle: "Типы цен продажи", ptHint: "Добавляйте, редактируйте или удаляйте", ptPlaceholder: "Например: Оптовая, Розничная...", ptAdd: "Добавить тип цены",
    added: "Добавлено", deleted: "Удалено", error: "Ошибка",
    dimsTitle: "Размеры", dimsHint: "— на одну штуку", length: "Длина", width: "Ширина", height: "Высота",
    pkgTitle: "Единицы упаковки", pkgBase: "Основная:", pkgNoBase: "Сначала выберите основную единицу измерения (UOM) в разделе \"Информация\"",
    pkgUnit: "Единица упаковки", pkgQty: "Количество", pkgUomSelect: "Ед. изм...", pkgAdd: "Добавить упаковку",
    editTitle: "Редактирование", newProduct: "Новый товар", newService: "Новая услуга",
    saved: "Обновлено", saveError: "Произошла ошибка", saving: "Сохранение...", update: "Обновить", save: "Сохранить", cancel: "Отмена",
    nameLabel: "Название", productNamePlaceholder: "Название товара", serviceNamePlaceholder: "Название услуги",
    infoTitle: "Информация", descLabel: "Описание", descPlaceholder: "Кратко о товаре...",
    folderLabel: "Папка", noFolder: "Без папки", select: "Выберите...", skuLabel: "SKU", skuPlaceholder: "Например: PRD-001",
    pricesTitle: "Цены", buyPrice: "Цена закупки", salePricesTitle: "Цены продажи", statusTitle: "Статус", back: "Назад", uomLabel: "Единица измерения", minStockLabel: "Мин. остаток", minStockHint: "Если остаток меньше или равен этому значению — попадёт в \"Низкий остаток\" (0 = без контроля)", configure: "Настроить", active: "Активен", activeBadge: "Актив", isManufacturedLabel: "Производится", prodNormaTitle: "Норма производства", prodNormaHint: "Сырьё, расходуемое при производстве 1 единицы продукта", prodNormaAdd: "Добавить", prodNormaProduct: "Сырьё", prodNormaQty: "Количество", prodNormaUom: "Единица", prodNormaFooter: "При выборе этого продукта в производстве норма подтянется автоматически", manufacturingUomLabel: "Единица изм. производства", manufacturingUomHint: "Автоматически подставляется в форму производства и не может быть изменена.", manufacturingUomNone: "Не указана (любая)",
    mkixCodeLabel: "Код МКИX", mkixCodePlaceholder: "Например: 3926909709",
    nameRequired: "Название товара обязательно", uomRequired: "Единица измерения обязательна",
  },

  products: {
    variantTag: "вар.",
    typeAll: "Все", product: "Товар", service: "Услуга",
    cols: { category: "Папка", uom: "Ед", sku: "SKU", costPrice: "Себестоимость", avgCost: "Ср. себест.", salePrice: "Цена продажи", stock: "Остаток", description: "Описание", createdAt: "Создан", updatedAt: "Обновлён", isActive: "Статус" },
    active: "Активен", inactive: "Неактивен",
    searchPlaceholder: "Поиск...", colsMenuTitle: "Настроить столбцы", colsMenu: "Столбцы", colsAll: "Все", colsDefault: "По умолчанию",
    folders: "Папки", newFolder: "Новая папка", allFolders: "Все", noFolders: "Нет папок", mobileAllFolders: "Все (папка)",
    resizeHint: "Потяните, чтобы изменить ширину (двойной клик — сброс)",
    thName: "Название", notFound: "Товары не найдены", createHint: "Добавьте первый товар или услугу", inactiveBadge: "Неактивен", stockLabel: "Остаток",
    uomRequired: "Выберите единицу измерения", editTitle: "Редактирование —", newProductTitle: "+ Новый товар", newServiceTitle: "+ Новая услуга",
    nameLabel: "Название", productNamePlaceholder: "Название товара", serviceNamePlaceholder: "Название услуги",
    skuLabel: "SKU / Код", uomLabel: "Единица измерения", select: "Выберите...",
    folderLabel: "Папка", noFolder: "Без папки", salePrice: "Цена продажи", costPriceLabel: "Себестоимость", descLabel: "Описание", optional: "Необязательно...",
    activeCheck: "Активен", cancel: "Отмена", save: "Сохранить", add: "Добавить", saving: "Сохранение...",
    folderEditTitle: "Редактировать папку", folderNamePlaceholder: "Название папки", parentFolder: "Родительская папка", rootFolder: "Корневая папка",
    deleteTitle: "Подтвердите удаление", deleteText: " — удалить? Это действие нельзя отменить.", delete: "Удалить", deleting: "Удаление...",
    saved: "Обновлено", added: "Добавлено", folderSaved: "Папка обновлена", folderAdded: "Папка добавлена", deleted: "Удалено", folderDeleted: "Папка удалена", error: "Произошла ошибка",
  },

  files: {
    empty: "Файл ещё не загружен", fileName: "Файл", uploading: "Загрузка...", upload: "Загрузить файл", hint: "PDF, изображение, Word, Excel — максимум 15 МБ", uploaded: "Загружено", uploadError: "Ошибка загрузки",
  },

  smeta: {
    title: "Смета", save: "Сохранить",
    companyName: "Название компании", companyNamePh: "Введите название компании",
    directorName: "Ф.И.О. директора", directorNamePh: "Фамилия Имя Отчество",
    colName: "Наименование работы", colCountry: "Страна", colUom: "Ед.изм",
    colQty: "Кол.в", colPrice: "Цена", colDeliveryCost: "Стоимость поставки",
    colVat: "НДС %", colTotal: "Общая стоимость с НДС",
    total: "Итого", addRow: "Добавить строку",
    comment: "Примечание", commentPh: "Дополнительные примечания...",
    validUntil: "Срок действия коммерческого предложения", validUntilLabel: "Действует до:",
    positions: "Товары и услуги", preview: "Просмотр", close: "Закрыть",
    download: "Скачать PDF", printPdf: "Печать / PDF", orderNum: "Заказ №",
    delivery: "Стоимость поставки", vat: "НДС", grandTotal: "Итого с НДС",
    shareLink: "Поделиться", linkCopied: "Скопировано!", linkError: "Ссылка недействительна",
  },

  jobOrderForm: { dimW: "Ширина", dimL: "Длина", back: "Назад", title: "Заказ", procStatus: { waiting: "Не начат", "in-progress": "В процессе", paused: "На паузе", done: "Завершён", problem: "Проблема" }, fSketch: "Эскиз (изображение/PDF)", sketchUpload: "Загрузить эскиз", toTrash: "В корзину", print: "Печать", printTitle: "Печать", deliver: "Завершён", revertDelivery: "Отменить завершение", confirmAction: "Подтвердить", startAction: "В работу", completeAction: "Завершить", statusChanged: "Статус изменён", startNeedProcess: "Сначала добавьте процесс (этап)", startNeedResponsible: "Назначьте ответственного на каждый процесс", save: "Сохранить", trackStart: "Начать", trackPause: "Пауза", trackDone: "Завершить", trackProblem: "Проблема", trackResume: "Продолжить", deleteTitle: "Переместить в корзину", deleteText: "Заказ будет перемещён в корзину. Остаток сырья вернётся.",
    durMin: "мин", durHour: "ч", distFromInstall: "Расстояние от точки установки",
    select: "Выберите...", search: "Поиск...", clearSelection: "— Очистить выбор —", notFound: "Не найдено",
    nameRequired: "Название обязательно", customerAdded: "Клиент добавлен", error: "Ошибка",
    newCustomer: "Новый клиент", nameLabel: "Название", customerNamePlaceholder: "Имя клиента", phone: "Телефон", cancel: "Отмена", add: "Добавить",
    docLoadError: "Документ не загружен", cashboxRequired: "Нужно выбрать кассу", amountInvalid: "Неверная сумма",
    paymentReceived: "Оплата принята", movedToTrash: "Перемещено в корзину", customerRequired: "Нужно выбрать клиента",
    warehouseRequired: "Нужно выбрать склад", agreedInvalid: "Неверная согласованная сумма",
    deadlineRequired: "Укажите срок сдачи", managerRequired: "Выберите менеджера проекта", agreedRequired: "Укажите согласованную сумму", descriptionRequired: "Введите описание",
    savedToast: "Сохранено", createdToast: "Создано", saveFirst: "Сначала сохраните заказ", delivered: "Доставлено", reverted: "Отменено",
    modalTitle: "Новый заказ", modalCreate: "Создать и продолжить", modalHint: "После сохранения добавите процессы, расходы и расчёт.",
    fManager: "Менеджер проекта", managerNone: "— Не выбрано —",
    basicInfo: "Основные данные", moveLeft: "Сдвинуть влево", moveRight: "Сдвинуть вправо",
    deliveredLockTitle: "Чтобы редактировать доставленный заказ, сначала отмените доставку",
    deliveredBanner: "Доставлено. Чтобы редактировать, сначала отмените доставку.",
    invoiceTitle: "Нужно отправить счёт-фактуру",
    invoiceText1: "Работа по этому заказу завершена. Контрагенту ", invoiceText2: " по ", invoiceText3: " договору нужно отправить счёт-фактуру.",
    contractAmount: "Сумма договора:",
    fNumber: "Номер", fDate: "Дата", fCustomer: "Клиент", customerPlaceholder: "Клиент...", newCustomerTitle: "Добавить нового клиента",
    fContract: "Договор", noContract: "— Без договора —", fAgreedPrice: "Согласованная сумма", fCurrency: "Валюта", fDeadline: "Срок сдачи",
    fWarehouse: "Склад (сырьё)", fFolder: "Папка", noFolder: "— Без папки —",
    fDescription: "Описание (что делается)", fShortName: "Краткое название", shortNamePlaceholder: "Например: Кухонная мебель", shortNameRequired: "Краткое название обязательно", sketchRequired: "Загрузка эскиза обязательна", descPlaceholder: "Стол, кухонная мебель...",
    fLocation: "Локация установки", fLocationHint: "— ссылка у клиента (Google Maps, Yandex)", openLink: "Открыть ссылку", copyLink: "Копировать", copied: "Скопировано",
    createdBy: "Создал:", priceLabel: "Цена:", paidLabel: "Оплата:", debtLabel: "Долг:", workedLabel: "Отработано:", receivePayment: "Принять оплату",
    processes: "Процессы", addProcess: "Процесс", noProcesses: "Процессов нет. Нажмите \"+ Процесс\".",
    addProcessTitle: "Новый процесс", editProcessTitle: "Редактировать процесс", addProcessHint: "Выберите отдел и ответственного", deptRequired: "Нужно выбрать отдел",
    pDept: "Отдел", pResponsible: "Ответственный", pStatus: "Статус", pLabor: "Труд", pAllocated: "Выделенная сумма", pNote: "Примечание", pNotePlaceholder: "Примечание / особое указание...", workedShort: "Отработано:", historyTitle: "История времени", calLoad: "заказ(ов)", calBusy: "загружено", historyEmpty: "Пока нет действий", fromProposal: "Этот заказ создан из предложения:", viewProposal: "Открыть предложение", proposalTitle: "Предложение", prDate: "Дата", prCustomer: "Клиент", prAssignee: "Назначенный сотрудник", prCreatedBy: "Создал", prDescription: "Описание", prNote: "Примечание", prFiles: "Файлы",
    materials: "Расходы (сырьё)", addRow: "Строка", noMaterials: "Расходов нет. Нажмите \"Строка\".",
    mProduct: "Товар", mQty: "Кол-во", mUom: "Ед", mCost: "Себестоимость", mSum: "Сумма", mProcess: "Процесс",
    stockLeft: "Остаток",
    selectVariant: "Выберите вариант",
    uomPlaceholder: "шт", costFromProductTitle: "Себестоимость из карточки товара", costOwnTitle: "Себестоимость для этого заказа", totalExpense: "Итого расход",
    files: "Файлы и проекты",
    totalsTitle: "Итоговый расчёт", tAgreed: "Согласованная сумма", tMaterials: "Сырьё", tLabor: "Труд", tTotalCost: "Итого себестоимость", tOtherExpenses: "Прочие расходы", otherExpenses: "Прочие расходы", addExpense: "Добавить расход", noExpenses: "Расходов нет", expCashbox: "Касса", expCashboxHint: "Только кассы в валюте заказа ({cur})", expCashboxRequired: "Выберите кассу", expAmount: "Сумма", expAmountRequired: "Введите сумму", expNote: "Комментарий", expNotePlaceholder: "Описание расхода…", expAdded: "Расход добавлен", expDeleted: "Расход удалён", tProfit: "Прибыль",
    totalsHint: "После сохранения записывается фактическая себестоимость (FIFO/средняя) и прибыль уточняется.",
    freezeAction: "Заморозить", unfreezeAction: "Продолжить",
    freezeTitle: "Заморозить заказ (пауза)", freezeHint: "При заморозке срок сдвигается вперёд. После разморозки прошедшее время не возвращается.",
    freezeUntilLabel: "Дата возобновления",
    freezeExtendInfo: "Срок будет продлён на {days} дн.",
    freezeConfirm: "Заморозить", freezeDateRequired: "Укажите дату возобновления",
    freezeSuccess: "Заказ заморожен", unfreezeSuccess: "Заказ возобновлён",
    frozenBanner: "Заморожен (на паузе)", frozenFrom: "с:", frozenUntil: "до:",
    deleteTextInvoice: " Автоматическая фактура также удаляется и баланс клиента возвращается.",
    payTitle: "Принять оплату", remainingDebt: "Остаток долга:", cashbox: "Касса", noCashbox: "касса в этой валюте не найдена",
    amount: "Сумма", payNote: "Примечание", optional: "Необязательно...", receive: "Принять",
  },

  proposals: {
    title: "Коммерческое предложение", countSuffix: "шт.", new: "Предложение", newTitle: "Новое предложение", editTitle: "Редактировать предложение", colNumber: "Номер", colDate: "Дата", colCustomer: "Клиент", colDescription: "Описание", colAmount: "Сумма", colAssignee: "Сотрудник", colCreatedBy: "Создал",
    searchPlaceholder: "Номер, клиент, описание...", notFound: "Предложения не найдены", loadError: "Ошибка загрузки",
    resizeHint: "Потяните, чтобы изменить ширину", backToList: "Назад к списку",
    emptyTitle: "Предложение не выбрано", emptyHint: "Выберите слева или создайте новое",
    tabs: { open: "Открытые", won: "Выиграно", lost: "Отказ" },
    statWon: "выиграно", statLost: "отказ", statOpen: "открыто",
    status: { new: "Новое", "in-discussion": "В обсуждении", won: "Выиграно (заказ)", lost: "Отклонено" },
    docLoadError: "Документ не загружен", customerRequired: "Нужно выбрать клиента",
    savedToast: "Сохранено", createdToast: "Создано", error: "Ошибка",
    markedLost: "Отмечено как отклонённое", deleteConfirm: "Удалить это предложение?", deletedToast: "Удалено",
    wonBannerText2: ".", openOrder: "Открыть заказ",
    lostBannerTitle: "Отклонённое предложение", reasonLabel: "Причина:",
    delete: "Удалить", rejected: "Отклонено", convertToOrder: "Преобразовать в заказ", cancel: "Отмена", save: "Сохранить",
    fNumber: "Номер", fDate: "Дата", fStatus: "Статус", fCurrency: "Валюта", fCustomer: "Клиент",
    fAgreedPrice: "Согласованная сумма", fWarehouse: "Склад (для заказа)", notSelected: "— Не выбрано —",
    fDescription: "Описание (что делается)", descPlaceholder: "Описание дизайна / проекта клиента...",
    fAdvance: "Сумма аванса (бронь)", advancePaid: "Аванс оплачен", fNote: "Примечание", optional: "Необязательно...", fFiles: "Файлы (эскиз/фото/документ)", createdBy: "Создал:",
    lostModalTitle: "Отклонить предложение", lostReasonLabel: "Причина (необязательно):", lostReasonPlaceholder: "Клиент принял решение...",
    winModalTitle: "Преобразовать в заказ",
    winModalText: "Будет создан новый заказ (JobOrder) и привязан к этому предложению. Процессы и материалы добавляются внутри заказа.",
    warehouseRequiredLabel: "Склад *", selectPlaceholder: "Выберите...", createOrder: "Создать заказ",
  },

  jobOrders: { title: "Заказы", subtitle: "Заказ клиента: производство → доставка", newOrder: "Заказ", notFound: "Заказ не найден", folderDeleteText: "папка будет удалена. Заказы внутри сохранятся (удалится только привязка к папке).", colsReorderHint: "Перетащите, чтобы изменить порядок",
    searchPlaceholder: "Номер, клиент, описание...",
    createHint: "Создайте новый заказ",
    loadError: "Ошибка загрузки",
    thNumber: "Номер",
    thActions: "Действия",
    filterAll: "Все",
    tabAll: "Все", tabFrozen: "Заморожены", overdue: "Срок истёк", costOverrun: "Себестоимость превышена",
    status: { new: "Новый", confirmed: "Подтверждён", "in-progress": "В процессе", delivered: "Завершён", cancelled: "Отменён" },
    cols: { sketch: "Эскиз", shortName: "Краткое название",
      date: "Дата", customer: "Клиент", description: "Описание", folder: "Папка", processes: "Процессы",
      manager: "Менеджер проекта", agreedPrice: "Согласовано", paid: "Оплачено", debt: "Долг",
      totalCost: "Себестоимость", materialsCost: "Сырьё", laborCost: "Труд",
      profit: "Прибыль", status: "Статус", createdBy: "Создал", expectedDeliveryDate: "Срок сдачи",
      deliveryDate: "Дата доставки", currency: "Валюта",
    },
    colsMenu: "Столбцы", colsMenuTitle: "Настроить столбцы", colsAll: "Все", colsDefault: "По умолчанию",
    statAgreed: "Общая сумма", filterCustomer: "Клиент", filterAllCustomers: "Все клиенты", filterAllManagers: "Все менеджеры", filterYear: "Год", filterPeriod: "Период", filterWholeYear: "Весь год", filterAllMonths: "Все месяцы", filterClear: "Сбросить", statPaid: "Оплачено", statDebt: "Долг", statCount: "Кол-во заказов",
    folders: "Папки", newFolder: "Новая папка", allFolders: "Все", noFolder: "Без папки",
    noFolders: "Нет папок", mobileAllFolders: "Все (папка)",
    folderEdit: "Редактировать папку", folderNameLabel: "Название", folderNamePlaceholder: "Название папки",
    parentFolder: "Родительская папка", rootFolder: "Корневая папка",
    folderDeleteTitle: "Удалить папку",
    trashTitle: "Переместить в корзину",
    trashText: "заказ будет перемещён в корзину. Остатки сырья вернутся.",
    cancel: "Отмена", save: "Сохранить", add: "Добавить", delete: "Удалить", toTrash: "В корзину",
    saved: "Обновлено", addedToast: "Добавлено", deletedToast: "Удалено", movedToTrash: "Перемещено в корзину", error: "Ошибка",
    resizeHint: "Потяните, чтобы изменить ширину (двойной клик — сброс)",
  },

  // Auth
  login: "Войти",
  register: "Регистрация",
  logout: "Выйти",
  email: "Email",
  phone: "Телефон",
  password: "Пароль",
  confirmPassword: "Подтвердите пароль",

  // Register
  createOrganization: "Создать организацию",
  organizationName: "Название организации",
  organizationType: "Тип организации",
  yourName: "Ваше имя",
  yourEmail: "Ваш email",
  yourPassword: "Пароль",
  alreadyHaveAccount: "Уже есть аккаунт?",
  dontHaveAccount: "Нет аккаунта?",

  // Org types
  retail: "Розничная торговля",
  wholesale: "Оптовая торговля",
  manufacturing: "Производство",
  service: "Услуги",
  other: "Другое",

  // Dashboard
  dashboard: "Главная",
  welcome: "Добро пожаловать",

  // Common
  save: "Сохранить",
  cancel: "Отмена",
  delete: "Удалить",
  edit: "Редактировать",
  add: "Добавить",
  search: "Поиск",
  error: "Ошибка",
  success: "Успешно",

  // Errors
  required: "Это поле обязательно для заполнения",
  invalidEmail: "Неверный email адрес",
  passwordMin: "Пароль должен содержать минимум 4 символов",
  passwordMatch: "Пароли не совпадают",

  // Login page
  login_page: {
    server: "Сервер",
    serverPlaceholder: "server...",
    checking: "проверяется...",
    serverNotFound: "Сервер не найден",
    serverNotFoundHint: "Сервер «{slug}» не существует. Проверьте адрес.",
    phonePlaceholder: "90 123 45 67",
    passwordPlaceholder: "••••••",
    submitting: "Вход...",
    rights: "© 2025 CRM Line. Все права защищены.",
  },

  // Sales module
  sales: {
    dateLocale: "ru-RU",
    types: {
      invoices: { label: "Продажи",   subtitle: "Счёт-фактуры продаж", docLabel: "Счёт-фактура" },
      returns:  { label: "Возвраты",  subtitle: "Возврат товара от клиента", docLabel: "Возврат продажи" },
    },
    statusDraft: "Черновик",
    statusConfirmed: "Подтверждён",
    searchPlaceholder: "Номер или клиент...",
    notFound: "Документ не найден",
    createHint: "Создайте новый документ",
    thNumber: "Номер",
    thDate: "Дата",
    thCustomer: "Клиент",
    thLines: "Строки",
    thSum: "Сумма",
    thStatus: "Статус",
    thVerified: "Проверен",
    thState: "Состояние",
    thCurrency: "Валюта", thNote: "Примечание",
    thActions: "Действия",
    linesSuffix: "шт.",
    view: "Просмотр",
    edit: "Редактировать",
    deleteConfirmTitle: "Подтвердите удаление",
    deleteConfirmText: "будет удалён.",
    deleteInvoiceExtra: " Остаток и долг клиента будут возвращены.",
    cancel: "Отмена",
    deleteBtn: "Удалить",
    deleted: "Удалено",
    loadError: "Ошибка загрузки",
    error: "Ошибка",
  },

  // Purchases module
  purchases: {
    dateLocale: "ru-RU",
    types: {
      receipts: { label: "Приходы",  subtitle: "Счёт-фактуры поставщиков (приходы)", docLabel: "Приходный документ" },
      returns:  { label: "Возвраты", subtitle: "Возврат товара поставщику", docLabel: "Возврат закупки" },
    },
    statusDraft: "Черновик",
    statusConfirmed: "Подтверждён",
    searchPlaceholder: "Номер или поставщик...",
    notFound: "Документ не найден",
    createHint: "Создайте новый документ",
    thNumber: "Номер",
    thDate: "Дата",
    thSupplier: "Поставщик",
    thLines: "Строки",
    thSum: "Сумма",
    thStatus: "Статус",
    thVerified: "Проверен",
    thState: "Состояние",
   thCurrency: "Валюта", thWarehouse: "Склад", thNote: "Примечание", thPayment: "Оплата", payCash: "Наличные", payCredit: "Долг",
    thActions: "Действия",
    linesSuffix: "шт.",
    view: "Просмотр",
    edit: "Редактировать",
    deleteConfirmTitle: "Подтвердите удаление",
    deleteConfirmText: "будет удалён.",
    cancel: "Отмена",
    deleteBtn: "Удалить",
    deleted: "Удалено",
    loadError: "Ошибка загрузки",
    error: "Ошибка",
  },

  // Sales form page
  salesForm: {
    docTypes: {
      invoices: "Счёт-фактура",
      returns: "Возврат продажи",
    },
    back: "Назад",
    delete: "Удалить",
    print: "Печать",
    copy: "Копия",
    cancel: "Отмена",
    save: "Сохранить",
    add: "Добавить",
    error: "Ошибка",
    statusManage: "Управление статусами",
    statusEdit: "Редактировать",
    statusNew: "Новый статус",
    statusNamePlaceholder: "Название статуса...",
    statusAdd: "Добавить",
    productSearchPlaceholder: "Поиск товара...",
    productNotFoundCreate: "Не найдено. Создайте новый товар через",
    productNotFoundCreate2: ".",
    catalogEmpty: "Каталог пуст — добавьте товар через +",
    productTypeName: "Введите название товара...",
    notFound: "Не найдено",
    searchPlaceholder: "Поиск...",
    customerSelect: "Выберите клиента...",
    customerAdded: "Клиент добавлен",
    newCustomer: "Новый клиент",
    nameRequired: "Название *",
    customerNamePlaceholder: "Имя клиента",
    phone: "Телефон",
    nameRequiredToast: "Название обязательно",
    warehouseSelect: "Выберите склад...",
    warehouseUpdated: "Обновлено",
    warehouseAdded: "Склад добавлен",
    editWarehouse: "Редактировать склад",
    newWarehouse: "Новый склад",
    warehouseNamePlaceholder: "Название склада",
    currency: "Валюта",
    baseLabel: "основная",
    uploadError: "Ошибка загрузки",
    file: "Файл",
    noFiles: "Файлы ещё не загружены",
    fileHint: "PDF, изображение, Word, Excel — максимум 15MB",
    productAdded: "Товар добавлен",
    newProduct: "Новый товар",
    productNamePlaceholder: "Название товара",
    costPrice: "Себестоимость",
    docLoadError: "Документ не загружен",
    customerRequired: "Нужно выбрать клиента",
    warehouseRequired: "Нужно выбрать склад",
    deadlineRequired: "Укажите срок сдачи",
    managerRequired: "Выберите менеджера проекта",
    agreedRequired: "Укажите согласованную сумму",
    descriptionRequired: "Введите описание",
    currencyRequired: "Нужно выбрать валюту",
    cashboxRequired: "Нужно выбрать кассу",
    dateInvalid: "Неверная дата (DD/MM/YYYY HH:MM)",
    deliveryDateInvalid: "Неверная дата поставки (DD/MM/YYYY)",
    needQty: "Укажите количество хотя бы для одной позиции",
    saved: "Сохранено",
    created: "Добавлено",
    copyNeedRow: "Для копирования нужна хотя бы одна строка",
    copyCreated: "Копия создана",
    deleted: "Удалено",
    productAlready: "Этот товар уже добавлен",
    dateLabel: "Дата:",
    dateMaskPlaceholder: "DD/MM/YYYY HH:MM",
    statusless: "Без статуса",
    verified: "Подтверждён",
    counterparty: "Контрагент *",
    newCounterpartyTitle: "Добавить контрагента",
    warehouse: "Склад",
    editWarehouseTitle: "Редактировать склад",
    newWarehouseTitle: "Добавить склад",
    currencyReq: "Валюта *",
    payment: "Оплата",
    payCredit: "В долг (клиент должен)",
    payCash: "Наличная оплата (в кассу)",
    payCashHint: "Сумма сразу поступает в кассу, на баланс клиента не влияет.",
    cashbox: "Касса",
    selectPlaceholder: "Выберите...",
    notSelected: "— Не выбрано —",
    arrivalDate: "Дата прихода",
    createInvoice: "Создать продажу",
    customerReq: "Клиент *",
    invoiceCreated: "Продажа создана (списано со склада)",
    newCustomerTitle: "Добавить клиента",
    priceType: "Тип цены",
    priceTypeDefault: "Стандарт (1-я цена)",
    cashboxBalance: "остаток",
    noCashbox: "Касса в валюте \"{currency}\" не найдена (или вам не привязана)",
    tabItems: "Позиции",
    tabFiles: "Файлы",
    thName: "Название",
    thSells: "Продаётся",
    thUom: "Ед.изм.",
    uomSelect: "Ед.изм.",
    uomRequired: "Выберите единицу измерения для каждого товара",
    overStock: "\"{name}\" — недостаточно на складе (доступно: {qty} {uom})",
    thAvailable: "Доступно",
    thPrice: "Цена",
    thDiscount: "Скидка %",
    thSum: "Сумма",
    thVatRate: "Ставка НДС",
    thVatAmount: "Сумма НДС",
    thTotal: "Итого",
    newProductTitle: "Создать новый товар",
    total: "Сумма",
    totalVat: "НДС",
    grandTotal: "Итого (с НДС)",
    note: "Примечание",
    notePlaceholder: "Примечание или доп. информация...",
    saleConfirmed: "Продажа подтверждена",
    saleConfirmedHint: "Остаток товара уменьшился, долг клиента вырос (+{amount}).",
    deleteConfirmTitle: "Подтвердите удаление",
    deleteConfirmText: "будет удалён навсегда.",
    partyLabel: "Клиент",
  },

  // Purchase form page
  purchaseForm: {
    docTypes: {
      receipts: "Приходный документ",
      returns: "Возврат закупки",
    },
    back: "Назад",
    delete: "Удалить",
    save: "Сохранить",
    createReceipt: "Создать приход",
    cancel: "Отмена",
    error: "Ошибка",
    statusManage: "Управление статусами",
    statusEdit: "Редактировать",
    statusNew: "Новый статус",
    statusNamePlaceholder: "Название статуса...",
    statusAdd: "Добавить",
    productSearchPlaceholder: "Поиск товара...",
    productNotFoundCreate: "Не найдено. Создайте новый товар через",
    productNotFoundCreate2: ".",
    catalogEmpty: "Каталог пуст — добавьте товар через +",
    productTypeName: "Введите название товара...",
    notFound: "Не найдено",
    supplierSelect: "Выберите поставщика...",
    supplierAdded: "Поставщик добавлен",
    newSupplier: "Новый поставщик",
    nameRequired: "Название *",
    supplierNamePlaceholder: "Название поставщика",
    phone: "Телефон",
    warehouseSelect: "Выберите склад...",
    warehouseUpdated: "Обновлено",
    warehouseAdded: "Склад добавлен",
    editWarehouse: "Редактировать склад",
    newWarehouse: "Новый склад",
    warehouseNamePlaceholder: "Название склада",
    nameRequiredToast: "Название обязательно",
    add: "Добавить",
    currency: "Валюта",
    uploadError: "Ошибка загрузки",
    file: "Файл",
    noFiles: "Файлы ещё не загружены",
    fileHint: "PDF, изображение, Word, Excel — максимум 15MB",
    productAdded: "Товар добавлен",
    newProduct: "Новый товар",
    productNamePlaceholder: "Название товара",
    costPrice: "Себестоимость",
    docLoadError: "Документ не загружен",
    productAlready: "Этот товар уже добавлен",
    selectVariant: "Выберите вариант",
    variantRequired: "Выберите вариант для товара с вариантами",
    supplierRequired: "Нужно выбрать поставщика",
    warehouseRequired: "Нужно выбрать склад",
    currencyRequired: "Нужно выбрать валюту",
    cashboxRequired: "Нужно выбрать кассу",
    dateInvalid: "Неверная дата (DD/MM/YYYY HH:MM)",
    deliveryDateInvalid: "Неверная дата поставки (DD/MM/YYYY)",
    needQty: "Укажите количество хотя бы для одной позиции",
    saved: "Сохранено",
    created: "Добавлено",
    copyNeedRow: "Для копирования нужна хотя бы одна строка",
    copyCreated: "Копия создана",
    receiptCreated: "Приход создан и оприходован на склад",
    deleted: "Удалено",
    statusless: "Без статуса",
    dateLabel: "Дата:",
    dateMaskPlaceholder: "DD/MM/YYYY HH:MM",
    verified: "Подтверждён",
    verifiedLockTitle: "Подтверждённый документ может отменить только администратор",
    counterparty: "Контрагент *",
    newCounterpartyTitle: "Добавить контрагента",
    editWarehouseTitle: "Редактировать склад",
    newWarehouseTitle: "Добавить склад",
    arrivalDate: "Дата прихода",
    dateOnlyPlaceholder: "DD/MM/YYYY",
    currencyReq: "Валюта *",
    paymentMode: "Способ оплаты",
    payDebt: "Долг (поставщику должны)",
    payDebtHint: "Баланс поставщика вырастет — затем оплачивается через Расход.",
    payCash: "Наличные (из кассы)",
    payCashHint: "Сумма сразу выходит из кассы, на баланс поставщика не влияет.",
    cashbox: "Касса",
    selectPlaceholder: "Выберите...",
    noCashbox: "Касса в валюте \"{currency}\" не найдена (или вам не привязана)",
      convRate: "Курс конвертации", convEdit: "Изменить курс", convDeducted: "Спишется с кассы",
    thName: "Название",
    thNeed: "Нужно",
    thReceived: "Получено", uploading: "Загрузка...", uploadFile: "Загрузить файл", uploaded: "Загружено", procLoadError: "Не удалось загрузить заявку снабжения", thOrdered: "Заказ",
    thAvailable: "Доступно",
    thPrice: "Цена",
    thDiscount: "Скидка %",
    thSum: "Сумма",
    newProductTitle: "Создать новый товар",
    overReceiveError: "Нельзя получить больше нужного количества",
    excludeFromReceipt: "Не включать в этот Приход",
    total: "Итого",
    note: "Примечание",
    notePlaceholder: "Примечание или доп. информация...",
    receiptConfirmed: "Приход подтверждён",
    receiptConfirmedHint: "Остаток товара обновлён, баланс поставщика увеличился (+{amount}).",
    deleteConfirmTitle: "Подтвердите удаление",
    deleteConfirmText: "будет удалён навсегда.",
    partyLabel: "Поставщик",
    warehouse: "Склад",
    warehouseNone: "— Не выбрано —",
    baseLabel: "основная",
    print: "Печать",
    copy: "Копия",
    tabItems: "Позиции",
    tabFiles: "Файлы",
    searchPlaceholder: "Поиск...",
    docNumberDash: "—",
    addRow: "Добавить строку",
  },

  // Procurement editor + form-page chrome
  procEditor: {
    back: "Назад",
    lockedTitle: "Документ не редактируется",
    lockedText: "Эта заявка относится к прошедшему дню ({date}). Документы за прошлые дни доступны только для просмотра.",
    toTrash: "В корзину",
    createReceipt: "Создать приход",
    cancel: "Отмена",
    save: "Сохранить",
    number: "Номер",
    date: "Дата",
    needBy: "Срок поставки",
    assignee: "Снабженец (ответственный)",
    statusPrefix: "Состояние:",
    receiptsLinked: "· привязано приходов: {n}",
    overdue: "Срок истёк",
    neededProducts: "Нужные товары",
    rowsCount: "строк: {n}",
    thProduct: "Товар",
    thImage: "Фото",
    thNeed: "Нужно",
    thUom: "Ед.",
    thReceived: "Получено",
    thRemaining: "Остаток",
    thNote: "Примечание",
    uomPlaceholder: "шт",
    optional: "Необязательно",
    addRow: "Добавить строку",
    note: "Примечание",
    notePlaceholder: "Необязательно...",
    attachments: "Вложение (фото/файл)",
    trashModalTitle: "Переместить в корзину",
    needRow: "Введите хотя бы одну строку", assigneeRequired: "Необходимо выбрать снабженца",
    saved: "Сохранено",
    created: "Создано",
    movedToTrash: "Перемещено в корзину",
    loadDocError: "Документ не загружен",
    error: "Ошибка",
  },

  // Procurement (Снабжение) list
  procurement: {
    dateLocale: "ru-RU",
    title: "Снабжение",
    countSuffix: "заявок",
    newRequestTitle: "Новая заявка",
    searchPlaceholder: "Номер, примечание...",
    unassigned: "— не назначен",
    positionsSuffix: "позиций", boughtOf: "{bought} из {total} куплено", uploadError: "Ошибка загрузки", imgZoom: "Увеличить", selectVariant: "Выберите вариант",  thDate: "Дата", thProduct: "Товар", thNeed: "Нужно", thUom: "Ед.", thNote: "Примечание", optional: "Необязательно...", thBuy: "Купить", addRow: "Добавить строку", flatHint: "Добавьте товар нижней строкой — он попадёт в сегодняшнюю заявку. Просроченные строки красные.", error: "Ошибка",
    resizeHint: "Потяните, чтобы изменить ширину (двойной клик — сброс)",
    backToList: "Назад к списку",
    newDocTitle: "Новая заявка на снабжение",
    emptyHint: "Выберите из списка слева или создайте новую заявку",
    loadError: "Ошибка загрузки",
    tabs: {
      overdue: "Просроченные",
      new: "Новые",
      partial: "Частично",
      fulfilled: "Выполнено",
    },
    status: {
      new: "Новый",
      partial: "Частично",
      fulfilled: "Выполнено",
      cancelled: "Отменён",
    },
  },

  // Dashboard home (Главная)
  dashboardHome: {
    dateLocale: "ru-RU",
    greeting: "Добро пожаловать, {name}!",
    today: "Сегодня {date}",
    noAccess: "Нет доступа к показателям или данные не загружены.",
    noWidgets: "Для вашей роли на главной нет показателей. Выберите раздел в меню слева.",
    kpiTodaySales: "Продажи сегодня",
    kpiMonthSales: "Продажи за месяц",
    kpiMonthProfit: "Прибыль за месяц",
    kpiInventory: "Стоимость склада",
    trendTitle: "Динамика продаж",
    trendPeriod: "14 дней",
    debtTheyOwe: "Нам должны",
    debtWeOwe: "Мы должны",
    debtNet: "Итого",
    counterparties: "Контрагенты",
    cashTitle: "Остатки в кассах",
    cashEmpty: "Касс нет",
    topDebtorsTitle: "Крупнейшие должники",
    noDebtors: "Должников нет",
    viewAll: "Все",
    recentTitle: "Последние операции",
    recentEmpty: "Операций пока нет",
    recent: {
      salesInvoice: "Продажа",
      purchaseReceipt: "Приход",
      paymentIn: "Приход платежа",
      paymentOut: "Расход платежа",
    },
  },

  // Sidebar navigation (keyed by NAV_ITEMS key)
  nav: { purchases: "Закупки", "purchases-orders": "Заявки", "sales-orders": "Заказы", "job-orders": "Заказы", "job-orders-orders": "Заказы", integrations: "Интеграции",
    dashboard: "Главная",
    contacts: "Контакты",
    tasks: "Задачи",
    inbox: "Inbox",
    calls: "Звонки",
    reviews: "Отзывы",
    funnels: "Воронки",
    "purchases-procurement": "Снабжение",
    "purchases-receipts": "Приходы",
    "purchases-returns": "Возвраты",
    sales: "Продажи",
    "sales-invoices": "Продажи",
    "sales-returns": "Возвраты",
    "job-orders-proposals": "Коммерческое предложение",
    inventory: "Товары",
    counterparties: "Контрагенты",
    "counterparties-list": "Контрагенты",
    "counterparties-contracts": "Договоры",
    "counterparties-aktsverka": "Акт-сверка",
    sklad: "Склад",
    "sklad-balances": "Остатки",
    "sklad-valuation": "Себестоимость",
    "sklad-transfers": "Перемещения",
    "sklad-warehouses": "Склады",
    "sklad-lowstock": "Низкий остаток",
    finance: "Финансы",
    "finance-balance": "Баланс компании",
    "finance-pnl": "Прибыль и убытки",
    "finance-analysis": "Анализ",
    "finance-payments": "Платежи", "finance-requests": "Заявки",
    "finance-debts": "Долги",
    "finance-conversions": "Конвертация",
    "finance-cashboxes": "Кассы",
    "finance-scheduled": "Обязательные платежи",
    "finance-assets": "Активы",
    production: "Производство",
    "production-orders": "Производство",
    "production-packaging": "Упаковка",
    "production-bom": "Рецепты (BOM)",
  },

  analysis: {
    title: "Анализ",
    subtitle: "Распределение поступивших средств по нормам расходов помесячно",
    income: "Поступило",
    allocated: "Выделено",
    spent: "Потрачено",
    available: "Доступно",
    carryIn: "С прошлого месяца",
    normSum: "Сумма норм",
    normHint: "Рекомендуется, чтобы сумма норм составляла 100%.",
    empty: "Нет категорий расходов.",
    remain: "Остаток",
    over: "Превышено",
    toNextMonth: "Переходит на след. месяц",
    loadError: "Ошибка загрузки данных",
    error: "Произошла ошибка",
    date: "Дата",
    total: "Итого",
    noSpend: "В этом месяце расходов не было.",
    spentTotal: "Всего потрачено",
    allocatedRow: "Доступно (норма)",
    carryShort: "(пр. месяц)",
    diffRow: "Разница → на след. месяц",
    diffHint: "Разница положительная — остаток переходит на следующий месяц; отрицательная — бюджет превышен.",
    readonly: "Только для чтения",
    noCounterparty: "Без контрагента",
    unitK: "тыс", unitM: "млн", unitB: "млрд",
    configNorms: "Настроить проценты",
    normsTitle: "Проценты категорий (норма)",
    normsHint: "Укажите, какой процент от месячного дохода выделяется каждой категории.",
    normsSaved: "Проценты сохранены",
    byCategoryTitle: "По категориям (за месяц)",
    colName: "Название",
    colSumma: "Сумма",
    colNorma: "Норма",
    colReal: "Реал %",
    colResult: "Результат",
    resultHint: "Результат = Норма − Реал. Плюс (зелёный) — потрачено меньше нормы; минус (красный) — превышение.",
    save: "Сохранить",
    cancel: "Отмена",
  },

  // Account settings page
  account: {
    title: "Настройки аккаунта",
    subtitle: "Редактирование личных данных",
    personalInfo: "Личные данные",
    name: "Имя",
    email: "Email",
    emailHint: "(для восстановления пароля)",
    emailPlaceholder: "example@mail.com",
    phone: "Телефон",
    phoneHint: "Номер телефона изменить нельзя",
    save: "Сохранить",
    saving: "Сохранение...",
    profileUpdated: "Профиль обновлён",
    genericError: "Произошла ошибка",
    changePassword: "Изменить пароль",
    currentPassword: "Текущий пароль",
    newPassword: "Новый пароль",
    confirmPassword: "Подтвердите новый пароль",
    passwordMismatch: "Новые пароли не совпадают",
    passwordTooShort: "Пароль должен содержать минимум 4 символов",
    passwordChanged: "Пароль успешно изменён",
    changePasswordBtn: "Изменить пароль",
    namePlaceholder: "Полное имя",
    role: "Роль",
    hide: "Скрыть",
    show: "Показать",
  },

  // Settings page
  settings: {
    title: "Настройки",
    back: "Назад",
    tabs: {
      general: "Общие настройки",
      branding: "Брендинг",
      modules: "Меню",
      users: "Пользователи",
      workers: "Рабочие",
      roles: "Роли",
      currencies: "Валюты",
      uom: "Единицы измерения",
      company: "Компания",
      assets: "Активы",
      trash: "Корзина",
      funnels: "Воронки",
      tasks: "Задачи",
      "deal-sources": "Источники сделок",
      "close-reasons": "Причины закрытия",
      "lead-forms": "Формы",
      goals: "Цели",
      integrations: "Интеграции",
      inbox: "Inbox",
      atc: "Телефония (АТС)",
      audit: "Журнал аудита",
    },
    groups: {
      general: "Общее", crm: "CRM", channels: "Интеграции", system: "Система",
    },
    branding: {
      title: "Брендинг",
      subtitle: "Название организации, логотип и фирменный цвет — приложение откроется в этом виде",
      orgName: "Название организации",
      orgNamePlaceholder: "Название компании",
      logo: "Логотип",
      removeLogo: "Удалить",
      brandColor: "Фирменный цвет",
      defaultGreen: "Стандартный (зелёный)",
      customColor: "Свой цвет", solidTitle: "Боковая/верхняя панель в исходном цвете", solidHint: "Если включено — боковое меню и верхняя панель показываются точно в выбранном цвете (без затемнения). Выключено — как сейчас, тёмный оттенок.",
      preview: "Предпросмотр",
      primaryBtn: "Основная кнопка",
      badge: "Метка",
      linkText: "Текст ссылки",
      save: "Сохранить",
      imageOnly: "Только файл изображения",
      uploadError: "Ошибка загрузки",
      nameRequired: "Название организации обязательно",
      saved: "Брендинг сохранён",
      error: "Ошибка",
    },
    users: {
      countPrefix: "Всего",
      countSuffix: "пользователей", searchPlaceholder: "Имя или телефон...", noResults: "Ничего не найдено",
      add: "Добавить",
      thUser: "Пользователь",
      thPhone: "Телефон",
      thRole: "Роль",
      thDept: "Отдел", noDept: "Без отдела",
      thStatus: "Статус",
      you: "Вы",
      userType: "Тип сотрудника", userTypeNone: "Обычный сотрудник", userTypeHint: "Выберите роль: снабженец / сотрудник процесса / менеджер проекта (необязательно)",
      snabjenist: "Снабженец",
      active: "Активен",
      inactive: "Неактивен",
      editTitle: "Редактировать",
      changePasswordTitle: "Изменить пароль",
      deleteTitle: "Удалить",
      newUser: "Новый пользователь",
      editUser: "Редактировать пользователя",
      name: "Имя",
      namePlaceholder: "Полное имя",
      role: "Роль", position: "Должность",
      dept: "Отдел",
      deptNone: "— Не выбрано —", deptMulti: "Отделы (несколько)", noDeptsYet: "Отделов пока нет", cpFolders: "Папки контрагентов (доступ)", cpFoldersHint: "Снабженец видит контрагентов только из отмеченных папок. Если не отмечено — все.", noFoldersYet: "Папок пока нет",
      snabjenistHint: "Если включено, отображается в списке \"Ответственный\" в форме Снабжения",
      customRole: "Роль (RBAC)",
      customRoleNone: "— Без ограничений (полный) —",
      customRoleHint: "При назначении роли пользователь ограничивается её правами. owner/admin всегда полный доступ.", roleHint: "Администратор - полные права (RBAC игнорируется). User - ограниченный; ниже можно выбрать кастомную роль.", adminFullHint: "Администратор имеет доступ ко всем модулям - кастомная роль (RBAC) не нужна.",
      processWorker: "Сотрудник процесса",
      processWorkerHint: "Назначается на процессы заказа и может начинать/завершать/ставить на паузу",
      projectManager: "Менеджер проекта", cashier: "Кассир",
      projectManagerHint: "Может быть выбран ответственным менеджером в заказе (отображается в списке при создании заказа)",
      permissions: "Права доступа",
      cashboxes: "Привязанные кассы (для снабженца)",
      cashboxesHint: "При наличном Приходе пользователь сможет выбирать только эти кассы. Если оставить пустым, пользователь не сможет делать наличный Приход.",
      phone: "Телефон",
      phonePlaceholder: "90 123 45 67",
      email: "Email",
      emailHint: "(для восстановления пароля)",
      emailPlaceholder: "example@mail.com",
      password: "Пароль",
      passwordPlaceholder: "Минимум 6 символов",
      newPassword: "Новый пароль",
      passwordModalTitle: "Пароль —",
      cancel: "Отмена",
      save: "Сохранить",
      saving: "Сохранение...",
      change: "Изменить",
      deleteUser: "Удалить пользователя",
      deleteConfirmPrefix: "Подтвердите удаление ",
      deleteConfirmSuffix: "? Это действие нельзя отменить.",
      deleteBtn: "Удалить",
      deleting: "Удаление...",
      accountOwner: "Владелец аккаунта",
      loadError: "Не удалось загрузить пользователей",
      updated: "Пользователь обновлён",
      passwordChanged: "Пароль изменён",
      deleted: "Пользователь удалён",
      added: "Пользователь добавлен",
      genericError: "Произошла ошибка",
      passwordTooShort: "Пароль должен содержать минимум 4 символов",
      roles: { owner: "Владелец", admin: "Администратор", user: "Пользователь", cashier: "Кассир" },
    },
    currencies: {
      baseTitle: "Основная валюта",
      baseSubtitle: "Все цены отображаются в этой валюте",
      change: "Изменить",
      baseTag: "Основная",
      basePickTitle: "Выберите основную валюту",
      basePickHint: "Первая выбранная валюта станет основной",
      addTitle: "Дополнительные валюты",
      addSubtitle: "Курс показывается относительно основной валюты",
      add: "Добавить",
      empty: "Дополнительные валюты ещё не добавлены",
      pickBaseModal: "Выберите основную валюту",
      pickAddModal: "Выберите валюту",
      searchPlaceholder: "Поиск (USD, доллар...)",
      notFound: "Не найдено",
      rateModalTitle: "Курс —",
      editRateModalTitle: "Изменить курс —",
      editRateTooltip: "Изменить курс", bankRate: "Курс банка:", useBankRate: "Курс банка", bankRateHint: "Если включено, курс берётся из Центробанка (CBU) и обновляется при сохранении.", bankRateOn: "Берётся из курса банка", bankSource: "Курс Центробанка, дата:", bankError: "Не удалось получить курс банка (можно ввести вручную).",
      ratePlaceholder: "Например: 12700",
      rateHint: "Введите, скольким {base} равен 1 {code}",
      cancel: "Отмена",
      save: "Сохранить",
      saving: "Сохранение...",
      addBtn: "Добавить",
      rateInvalid: "Введите корректный курс",
      baseFirst: "Сначала выберите основную валюту",
      saved: "Настройки валют сохранены",
      error: "Произошла ошибка",
      names: {
        UZS: "Узбекский сум", USD: "Доллар США", EUR: "Евро", RUB: "Российский рубль",
        KZT: "Казахский тенге", GBP: "Фунт стерлингов", JPY: "Японская иена",
        CNY: "Китайский юань", TRY: "Турецкая лира", AED: "Дирхам ОАЭ", KGS: "Киргизский сом",
        TJS: "Таджикский сомони", TMT: "Туркменский манат", AZN: "Азербайджанский манат",
        GEL: "Грузинский лари", UAH: "Украинская гривна", BYN: "Белорусский рубль",
        SAR: "Саудовский риял", CAD: "Канадский доллар", AUD: "Австралийский доллар",
        CHF: "Швейцарский франк", INR: "Индийская рупия", KRW: "Южнокорейская вона",
        SEK: "Шведская крона", NOK: "Норвежская крона", DKK: "Датская крона",
        PLN: "Польский злотый", CZK: "Чешская крона", HUF: "Венгерский форинт", RON: "Румынский лей",
      },
    },
    general: {
      saved: "Сохранено",
      error: "Ошибка",
      soonBadge: "(скоро)",
      businessTitle: "Тип бизнеса",
      businessSubtitle: "Выберите, какие модули нужны вашей организации — боковое меню очистится соответственно",
      businessNote: "Режим влияет только на интерфейс — данные всегда сохраняются. Чтобы снова показать модуль, выберите \"Всё\".",
      skladTitle: "Склад", paymentsTitle: "Платежи", paymentsSubtitle: "Настройки документов прихода/расхода.", paymentStatusesTitle: "Статусы платежей", paymentStatusesHint: "Если включено, в приходе и расходе появляется поле статуса — можно добавлять/удалять статусы. Если выключено, поле статуса скрыто.", purchasesTitle: "Закупки", purchasesSubtitle: "Настройки документов закупок.", purchaseReturnsTitle: "Возврат закупок", salesTitle: "Разделы продаж", salesSubtitle: "Выберите, какие подразделы видны в меню Продажи.", salesOrders: "Заказы", salesInvoices: "Продажи (счета)", salesReturns: "Возвраты", salesSectionsHint: "Выключенный раздел скрывается из меню. Если выключить все — группа Продажи не показывается.", salesProductFolder: "Папка товаров", salesProductFolderHint: "В форме продажи показываются только товары из этой папки (и вложенных). Пусто = все.", purchaseReturnsHint: "Если включено, в разделе Закупки виден «Возврат». Если выключено — скрыт.", discountFieldTitle: "Поле скидки", discountFieldHint: "Если включено, в приходе и счетах продаж появляется столбец скидки (%). По умолчанию скрыт.", purchaseDefaultWarehouse: "Склад по умолчанию", purchaseDefaultWarehouseHint: "Склад, выбираемый автоматически при создании документов прихода. Пусто = не выбран.", productionDefaultWarehouses: "Склады по умолчанию", productionDefaultWarehousesHint: "Склады, выбираемые автоматически при создании документов производства.", productionDefaultRawWarehouse: "Склад сырья", productionDefaultFinishedWarehouse: "Склад готовой продукции", jobProcLaborTitle: "Оплата труда в процессе", jobProcLaborHint: "Показывает поле оплаты труда в процессах заказа. Если выключено — скрыто.", jobProcAllocatedTitle: "Выделенная сумма процесса", jobProcAllocatedHint: "Показывает поле выделенной суммы в процессах заказа. Если выключено — скрыто.", sketchRequiredTitle: "Эскиз обязателен", sketchRequiredHint: "Если включено, при создании заказа загрузка эскиза (изображение/PDF) обязательна. Если выключено (по умолчанию) — необязательно.", sketchInListTitle: "Эскиз в списке заказов", sketchInListHint: "Если включено, в списке заказов (после #) показывается 1-е изображение (эскиз) — по клику на лупу открывается полностью. Если изображения нет — пустой квадрат. По умолчанию выключено.", costWarnTitle: "Процент предупреждения о себестоимости", costWarnHint: "Если себестоимость заказа превышает этот процент от согласованной цены, в списке появляется красное предупреждение (для заказов в работе и завершённых). Например 50% — себестоимость больше половины цены. По умолчанию 50%.", ndsTitle: "Налог (НДС)", ndsSubtitle: "Включите, если организация является плательщиком НДС — в счетах продаж появятся колонки НДС.", hasNdsTitle: "Организация — плательщик НДС", hasNdsHint: "При включении в счетах продаж появятся колонки: код МКИX, ставка НДС, сумма НДС и Итого.", negCashboxTitle: "Касса может уходить в минус", negCashboxHint: "Если включено, расход может превысить остаток и баланс уйдёт в минус. Если выключено (по умолчанию) — расход больше остатка запрещён.", cashierTitle: "Кассир", cashierSubtitle: "Какие кассы видны сотрудникам типа Кассир.", cashierNoCashboxes: "Касс нет.", cashierHint: "Кассиру видны только отмеченные кассы. Если не отмечено ничего — ни одной.", cashierCpTitle: "Кассир — папки контрагентов", cashierCpSubtitle: "Из каких папок контрагенты доступны кассиру при приходе.", cashierNoFolders: "Папок нет.", cashierCpHint: "Кассиру видны только контрагенты из отмеченных папок. Если не отмечено ничего — ни одного.", snabjenistCpTitle: "Снабженист — папки поставщиков", snabjenistCpSubtitle: "Из каких папок поставщики видны снабженисту.", snabjenistCpHint: "Снабженисту видны только контрагенты из отмеченных папок. Если не отмечено ничего — видны все.", catCpTitle: "Категория \u2014 папка контрагентов", catCpSubtitle: "При выборе категории в платеже список контрагентов фильтруется по этой папке.", catCpEmpty: "Категорий нет.", catCpHint: "Для категории с \"Без контрагента\" (например Продукты) контрагент не запрашивается.", catCpAll: "Все контрагенты", catCpNone: "Без контрагента", catCpIncoming: "приход", catCpOutgoing: "расход",
      skladSubtitle: "Настройки продаж и остатков",
      jobFoldersTitle: "Показывать папки",
      negStockTitle: "Разрешить отрицательный остаток",
      negStockHint: "Если включено, можно продавать товар, которого нет на складе (остаток уйдёт в минус). Если выключено, при нехватке товара счёт продажи блокируется.",
      servSellTitle: "Продажа услуг",
      servSellHint: "Если включено, в инвентаре появятся кнопка \"+ Услуга\" и фильтр \"Услуга\" — можно добавлять и продавать позиции-услуги. Если выключено, работа только с товарами.",
      purchasesNote: "Режим влияет только на интерфейс — существующие данные сохраняются.",
      costingTitle: "Учёт себестоимости (COGS)",
      costingSubtitle: "Каким методом рассчитываются прибыль и стоимость склада",
      costingNote: "Примечание: при продаже себестоимость \"замораживается\" — при смене метода прибыль старых документов не меняется.",
      cpSectionTitle: "Контрагенты", cpStatusTitle: "Статус контрагента", cpStatusHint: "Включает поле статуса для контрагентов. Если выключено — колонка/фильтр/поле статуса скрыты.", cpFolderTitle: "Фильтр контрагентов", cpFolderSubtitle: "Фильтрация контрагентов по папке в формах",
      cpFolderAll: "Все (без фильтра)",
      cpSupplierFolder: "Папка для закупок / снабжения", cpSupplierFolderHint: "В формах закупок и снабжения показываются только поставщики из этой папки",
      cpCustomerFolder: "Папка для продаж / заказов", cpCustomerFolderHint: "В формах продаж и заказов показываются только клиенты из этой папки",
      cpFolderNone: "Без папки",
      cpJobOrderNewCustomerFolder: "Папка для новых клиентов в заказах", cpJobOrderNewCustomerFolderHint: "Новый клиент, добавленный из формы заказа, попадёт в эту папку", prodFolderTitle: "Производство — папки товаров", prodFolderSubtitle: "В форме производства выбор сырья и готовой продукции фильтруется по этим папкам (включая вложенные).", prodRawFolder: "Папка сырья", prodRawFolderHint: "В составе производства (сырьё) показываются только товары из этой папки. Пусто = все.", prodFinishedFolder: "Папка готовой продукции", prodFinishedFolderHint: "В выходе производства (готовая продукция) показываются только товары из этой папки. Пусто = все.", prodOutputBatchTitle: "Партия и срок годности готовой продукции", prodOutputBatchHint: "Если включено — в производстве появляются поля партии (№) и срока годности для готовой продукции. По умолчанию выключено.", navOrderTitle: "Порядок разделов", navOrderSubtitle: "Настройте порядок отображения разделов в боковой панели.", navOrderReset: "Сбросить",
      costing: {
        average: { label: "Средневзвешенная (AVCO)", hint: "Средняя себестоимость рассчитывается автоматически из приходов" },
        manual:  { label: "Вручную (себестоимость товара)", hint: "Используется себестоимость, введённая вручную" },
        fifo:    { label: "FIFO (первый пришёл — первый ушёл)", hint: "Послойная себестоимость: самая старая партия продаётся первой" },
        batch:   { label: "По партии (лоту)", hint: "При продаже выбирается партия, со сроком" },
      },
      business: {
        "job-order": { label: "Сборка (заказы)", hint: "Работает по заказу клиента — готовый товар не хранится на складе, передаётся клиенту напрямую. Модули Продажи и Производство скрыты." },
        production:  { label: "Производство", hint: "Производит готовую продукцию из сырья и продаёт её. Раздел Производство виден, модуль Заказы скрыт." },
      },
      procurement: {
        orders:      { label: "Заявки", hint: "Прямой заказ поставщику (PO) — простая модель работы." },
        procurement: { label: "Снабжение", hint: "Внутренний процесс снабжения: запрос снабженца → приход на склад. Для компаний с большой командой." },
        both:        { label: "Оба", hint: "Заявки и Снабжение — оба подменю видны." },
        none:        { label: "Только приходы", hint: "Заявки и Снабжение скрыты — только Приходы (и Возвраты)." },
      },
    },
  },

  // Settings → UOM & Company tabs
  settingsExtra: {
    uom: {
      customTitle: "Мои единицы измерения",
      customSubtitle: "Добавленные вами, можно удалять",
      add: "Добавить",
      customEmpty: "У вас пока нет своих единиц",
      thShort: "Краткое",
      thFull: "Полное название",
      deleteTitle: "Удалить",
      systemTitle: "Системные единицы измерения",
      systemSubtitle: "Общие для всех организаций, удалить нельзя",
      systemBadge: "Система", thVisible: "Видно", visibleHint: "Если отмечено — отображается в системе (формах и списках)", addDisabled: "Пока отключено",
      newUnit: "Новая единица измерения",
      shortName: "Краткое название",
      shortNamePlaceholder: "Например: кг, шт, м²",
      shortNameHint: "Краткое обозначение в карточке товара",
      fullName: "Полное название",
      fullNamePlaceholder: "Например: Килограмм, Штука, Квадратный метр",
      cancel: "Отмена",
      saving: "Сохранение...",
      addBtn: "Добавить",
      added: "Единица измерения добавлена",
      deleted: "Единица измерения удалена",
      loadError: "Не удалось загрузить единицы измерения",
      error: "Произошла ошибка",
      groups: {
        count: "Количество",
        weight: "Вес",
        length: "Длина",
        areaVol: "Площадь и объём",
        liquid: "Жидкость",
        packaging: "Упаковка и тара",
        time: "Время",
        service: "Услуги",
        other: "Другое",
      },
    },
    trash: {
      retentionLabel: "Срок хранения",
      never: "Никогда не удалять",
      neverMark: "Не удаляется",
      retentionSaved: "Срок сохранён",
      subtitleNever: "записи никогда не удаляются автоматически. При восстановлении возвращаются и связанные данные (заметки, привязки).",
      title: "Корзина",
      subtitlePrefix: "Удалённые записи",
      subtitleSuffix: "навсегда удаляются через указанное число дней. При восстановлении возвращаются и связанные данные (заметки, привязки).",
      searchPlaceholder: "Название, телефон...",
      empty: "Корзина пуста",
      thType: "Тип",
      thDetails: "Детали",
      thName: "Название",
      thDeletedBy: "Кто удалил", allTypes: "Все типы", allUsers: "Все пользователи",
      kinds: { Contact: "Контакт", Deal: "Сделка", Task: "Задача", Funnel: "Воронка" },
      thDate: "Дата",
      thLeft: "Осталось",
      daysSuffix: "дн.",
      restoreTitle: "Восстановить",
      permDeleteTitle: "Удалить навсегда",
      modalTitle: "Удалить навсегда",
      confirmSuffix: "— удалить навсегда? Это действие нельзя отменить — запись и прикреплённые файлы будут удалены. Если это воронка, её сделки тоже удалятся.",
      cancel: "Отмена",
      deleting: "Удаление...",
      permDeleteBtn: "Удалить навсегда",
      restored: "Восстановлено",
      restoreError: "Ошибка восстановления",
      permDeleted: "Удалено навсегда",
      deleteError: "Ошибка удаления",
      loadError: "Ошибка загрузки",
    },
    audit: {
      title: "Журнал аудита",
      subtitle: "Кто, когда и что сделал",
      thTime: "Время",
      thUser: "Пользователь",
      thAction: "Действие",
      thBranch: "Отдел",
      thObject: "Объект",
      thIp: "IP",
      view: "Просмотр",
      detailTitle: "Детали записи",
      fResource: "Отдел / ресурс",
      fId: "ID объекта",
      fMethod: "Метод",
      fPath: "Адрес",
      fStatus: "Статус",
      allUsers: "Все пользователи",
      dateFrom: "С даты",
      dateTo: "По дату",
      thModule: "Модуль",
      modules: { trash: "Корзина", organization: "Настройки", uom: "Единицы измерения", inventory: "Товары", counterparty: "Контрагенты", warehouse: "Склады", purchases: "Закупки", sales: "Продажи", payments: "Платежи", "payment-requests": "Запросы на оплату", integrations: "Интеграции", cashbox: "Кассы", conversions: "Конвертация", transfers: "Перемещения", reports: "Отчёты", upload: "Файлы", trash: "Корзина", export: "Экспорт", production: "Производство", departments: "Отделы", branches: "Филиалы", "job-orders": "Заказы", proposals: "Предложения", "job-order-folders": "Папки заказов", contracts: "Договоры", "akt-sverka": "Акт сверки", procurement: "Снабжение",
        contacts: "Контакты", funnels: "Воронки", tasks: "Задачи", "lead-forms": "Лид-формы", inbox: "Входящие", instagram: "Instagram", facebook: "Facebook", whatsapp: "WhatsApp", atc: "IP-телефония", "lead-journey": "Путь лида", email: "Email", push: "Push-уведомления", reviews: "Отзывы", yandex: "Яндекс",
        "organization-users": "Пользователи", "organization-roles": "Роли", "organization-currencies": "Настройки валют", "organization-settings": "Общие настройки", "organization-contact-fields": "Поля контакта", "organization-deal-fields": "Поля сделки", "organization-task-stages": "Этапы задач", "organization-deal-sources": "Источники сделок", "organization-close-reasons": "Причины закрытия", "organization-goals": "Цели", "organization-sticker-packs": "Наборы стикеров", "organization-telegram-bot": "Telegram-бот", "organization-telegram-accounts": "Telegram-аккаунт",
        "funnels-deals": "Сделки", "funnels-deal-activities": "Комментарии к сделке", "funnels-deal-files": "Файлы сделки", "contacts-activities": "Комментарии к контакту" },
      actions: { create: "Создал", update: "Изменил", delete: "Удалил", login: "Вход", logout: "Выход", register: "Регистрация", password_change: "Сменил пароль", profile_update: "Обновил профиль" },
      loadError: "Ошибка загрузки",
    },
    company: {
      subBranches: "Филиалы",
      subDepartments: "Отделы",
      branches: {
        title: "Филиалы",
        subtitle: "Филиалы организации — отделы можно привязывать к этим филиалам",
        add: "Добавить",
        empty: "Филиалов нет",
        thName: "Название",
        thActions: "Действия",
        newBranch: "Новый филиал",
        editBranch: "Редактировать филиал",
        name: "Название",
        namePlaceholder: "Главный офис, филиал Чиланзар...",
        nameRequired: "Название обязательно",
        cancel: "Отмена",
        save: "Сохранить",
        deleteTitle: "Удалить филиал",
        deleteSuffix: "— удалить этот филиал? У отделов этого филиала привязка к филиалу будет снята (сами отделы сохранятся).",
        deleteBtn: "Удалить",
        added: "Добавлено",
        updated: "Обновлено",
        deleted: "Удалено",
        loadError: "Ошибка загрузки",
        error: "Ошибка",
      },
      departments: {
        title: "Отделы (производственные процессы)",
        subtitle: "Процессы внутри заказа выбираются из этих отделов (резка, склейка, покраска...)",
        add: "Добавить",
        empty: "Отделов нет",
        thName: "Название",
        thBranch: "Филиал",
        thActions: "Действия",
        newDept: "Новый отдел",
        editDept: "Редактировать отдел",
        name: "Название",
        namePlaceholder: "Резка, Покраска...",
        branch: "Филиал",
        branchNone: "— Не выбрано —",
        thType: "Тип",
        type: "Тип отдела",
        typeProcess: "Рабочий процесс",
        typeManagement: "Управление",
        typeHint: "При добавлении процесса заказа показываются только отделы \"рабочего процесса\" (не управленческие).",
        cancel: "Отмена",
        save: "Сохранить",
        deleteTitle: "Удалить отдел",
        deleteSuffix: "— удалить этот отдел? Соответствующая привязка у пользователей будет снята (но сами пользователи сохранятся).",
        deleteBtn: "Удалить",
        added: "Отдел добавлен",
        updated: "Обновлено",
        deleted: "Удалено",
        loadError: "Ошибка загрузки",
        error: "Ошибка",
      },
    },
  },

  // Top navbar
  topbar: {
    accountSettings: "Настройки аккаунта",
    settings: "Настройки",
    refresh: "Обновить",
    fullscreen: "Полный экран",
    exitFullscreen: "Выйти из полного экрана",
    roles: {
      owner: "Владелец",
      admin: "Админ",
      manager: "Менеджер",
      cashier: "Кассир",
      warehouse: "Кладовщик",
      viewer: "Наблюдатель",
    },
  },
  assets: {
    pageTitle: "Активы предприятия", pageSubtitle: "Оборудование, мебель и другие материальные ценности",
    addBtn: "Добавить актив", searchPlaceholder: "Название или инв. ID...",
    statTotal: "Всего активов", statUnit: "шт", statCost: "Первоначальная стоимость",
    statAccDep: "Амортизация", statBookValue: "Остаточная стоимость", currency: "сум",
    catAll: "Все категории",
    cat_furniture: "Мебель", cat_electronics: "Электроника",
    cat_computer: "Компьютеры и техника", cat_vehicle: "Транспорт",
    cat_equipment: "Производственное оборудование", cat_office: "Офисное оборудование", cat_other: "Прочее",
    statusAll: "Все статусы", statusActive: "Активный", statusDisposed: "Списан",
    status_active: "Активный", status_disposed: "Списан",
    thInventoryId: "Инв. ID", thName: "Наименование", thCategory: "Категория",
    thCost: "Перв. стоимость", thAccDep: "Амортизация", thBookValue: "Остаточная стоимость",
    thStatus: "Статус", thActions: "Действия",
    noItems: "Активы отсутствуют",
    deleteConfirm: "Удалить актив?",
    deleteHint: "Все записи амортизации также будут удалены.",
    deleteBtn: "Удалить", cancel: "Отмена", deleted: "Актив удалён",
    saved: "Сохранено", created: "Актив добавлен",
    formTitleNew: "Новый актив", formTitleEdit: "Редактировать актив",
    saveBtn: "Сохранить", backBtn: "Назад",
    sectionMain: "Основные данные", sectionFinance: "Финансовые данные",
    sectionDepreciation: "Амортизация", sectionHistory: "История амортизации",
    nameLabel: "Наименование", namePlaceholder: "Напр.: HP EliteBook 840",
    categoryLabel: "Категория", statusLabel: "Статус",
    descriptionLabel: "Описание", descriptionPlaceholder: "Дополнительная информация...",
    locationLabel: "Расположение / Отдел", locationPlaceholder: "Напр.: Финансовый отдел",
    responsibleLabel: "Ответственный", responsiblePlaceholder: "Ф.И.О.",
    purchaseDateLabel: "Дата покупки", purchaseCostLabel: "Первоначальная стоимость (сум)",
    disposalDateLabel: "Дата списания",
    disposalNoteLabel: "Причина списания", disposalNotePlaceholder: "Устарело, продано...",
    depMethodLabel: "Метод амортизации",
    depMethodNone: "Без амортизации", depMethodStraightLine: "Линейный метод",
    usefulLifeLabel: "Срок полезного использования (мес.)",
    monthlyDepLabel: "Ежемесячная амортизация", annualDepLabel: "Годовая амортизация",
    accDepLabel: "Накопленная амортизация", bookValueLabel: "Остаточная (балансовая) стоимость",
    noteLabel: "Примечание", notePlaceholder: "Заметка...",
    addDepBtn: "Начислить амортизацию",
    depModalTitle: "Начисление амортизации",
    depDateLabel: "Дата", depAmountLabel: "Сумма",
    depNoteLabel: "Примечание", depNotePlaceholder: "Напр.: Амортизация июнь 2026",
    depSaveBtn: "Записать", depAdded: "Амортизация начислена", depDeleted: "Запись удалена",
    suggestedDep: "Рекомендуемая сумма",
    depAmountRequired: "Укажите сумму",
    noDepHistory: "Записей амортизации нет",
    nameRequired: "Укажите наименование", categoryRequired: "Выберите категорию",
    thDepDate: "Дата", thDepAmount: "Сумма", thDepNote: "Примечание",
    catNone: "Без категории", catEmpty: "Категорий нет — добавьте в Настройках",
    statusNone: "Без статуса", statusEmpty: "Статусов нет — добавьте в Настройках",
    statusAllFilter: "Все статусы",
    depMethodStraightLineHint: "Равномерное списание",
    monthsSuffix: "мес.",
  },
  settingsAssets: {
    tabLabel: "Активы",
    title: "Настройки активов",
    catTitle: "Категории",
    catSubtitle: "Категории для группировки активов",
    statusTitle: "Статусы",
    statusSubtitle: "Для обозначения текущего состояния актива",
    addCatBtn: "Добавить категорию",
    addStatusBtn: "Добавить статус",
    namePlaceholder: "Название...",
    colorLabel: "Цвет",
    saveBtn: "Сохранить",
    cancelBtn: "Отмена",
    noCats: "Категорий нет",
    noStatuses: "Статусов нет",
    deleted: "Удалено",
    saved: "Сохранено",
    created: "Добавлено",
    dupError: "Такое название уже существует",
  },

  // ── CRM-specific pages ─────────────────────────────────────────────────────

  crmDashboard: {
    greeting: "Добро пожаловать, {name}!",
    loadError: "Не удалось загрузить данные",
    reload: "Обновить",
    kpiCalls: "Звонки сегодня",
    kpiContacts: "Новые контакты",
    kpiDeals: "Открытые сделки",
    kpiUnanswered: "Ожидают ответа",
    kpiSubToday: "сегодня",
    kpiSubTodayAdded: "добавлено сегодня",
    kpiSubTotal: "всего",
    kpiSubUnanswered: "без ответа",
    missedTitle: "Пропущенные звонки",
    missedEmpty: "Пропущенных звонков нет",
    allCalls: "Все звонки →",
    allTasks: "Все задачи →",
    overdueTitle: "Просроченные задачи",
    dueDate: "Срок:",
    activityTitle: "Последняя активность",
    activityEmpty: "Активности нет",
    funnelTitle: "Статистика воронки",
    funnelEmpty: "Воронок нет",
    noDeal: "Сделок нет",
    quickLinks: "Быстрые ссылки",
    addContact: "Добавить контакт",
    callHistory: "История звонков",
    incoming: "Входящий",
    outgoing: "Исходящий",
  },

  tasks: {
    title: "Задачи",
    newTask: "Новая задача",
    editTask: "Редактировать задачу",
    viewTask: "Просмотр задачи",
    close: "Закрыть",
    noStagesTitle: "Задачи",
    noStages: "Этапы не настроены. Перейдите в Настройки → Задачи.",
    search: "Поиск...",
    filter: "Фильтр",
    clearFilters: "Сбросить",
    allPriorities: "Все",
    allAssignees: "Все сотрудники",
    assignedToMe: "Назначено мне",
    createdByMe: "Созданные мной",
    overdue: "просрочено",
    totalNote: "Всего {total} — показаны первые {shown}",
    deleteConfirm: "Удалить задачу?",
    prioLow: "Низкий",
    prioMedium: "Средний",
    prioHigh: "Высокий",
    modalTitle: "Заголовок *",
    titlePlaceholder: "Что нужно сделать...",
    titleRequired: "Заголовок обязателен",
    description: "Описание / заметка",
    descPlaceholder: "Подробное описание...",
    priority: "Приоритет",
    stage: "Этап",
    assignee: "Ответственный",
    additionalAssignees: "Дополнительные ответственные",
    unassigned: "Не назначен",
    dueDate: "Срок",
    contact: "Контакт",
    contactSearch: "Поиск контакта...",
    linked: "Привязан",
    files: "Файлы",
    uploadFile: "+ Загрузить файл",
    uploading: "Загрузка...",
    tags: "Теги",
    tagsPlaceholder: "Добавить тег, нажмите Enter...",
    createdByPrefix: "Добавил:",
    historyTitle: "История изменений",
    histUnknownUser: "Неизвестно",
    histCreated: "создал задачу",
    histStageChanged: "изменил этап",
    histAssigned: "назначил ответственного",
    histUnassigned: "снял ответственного",
    histArchived: "архивировал",
    histUnarchived: "вернул из архива",
    histCompleted: "отметил как выполненную",
    archive: "Архив", archived: "Задача заархивирована", archiveEmpty: "В архиве нет задач",
    restore: "Восстановить", restored: "Задача восстановлена",
    assignedToPrefix: "Назначено:",
    cancel: "Отмена",
    save: "Сохранить",
    create: "Создать",
    saved: "Сохранено",
    created: "Создано",
    deleted: "Удалено",
    loadError: "Ошибка загрузки",
    error: "Ошибка",
    viewKanban: "Канбан",
    viewDue: "По сроку",
    viewCalendar: "Календарь",
    viewDay: "День",
    viewWeek: "Неделя",
    viewMonth: "Месяц",
    noDateBucket: "Без даты",
    colOverdue: "Просроченные",
    colToday: "На сегодня",
    colTomorrow: "На завтра",
    colThisWeek: "На эту неделю",
    colNextWeek: "На след. неделю",
    completeTitle: "Завершить задачу",
    outcomeNotePlaceholder: "Результат: о чём договорились...",
    logToDeal: "Записать в историю сделки",
    createFollowUp: "Создать следующую задачу",
    followUpTitle: "Заголовок следующей задачи",
    followUpDue: "Срок следующей задачи",
    followUpAssignee: "Ответственный (необязательно)",
    completeConfirm: "Завершить",
    completeSuccess: "Задача завершена",
    markDone: "Я выполнил",
    noDoneStage: "Этап «Выполнено» не настроен",
    doneBadge: "Выполнено",
  },

  calls: {
    title: "Звонки",
    all: "Все",
    incoming: "Входящие",
    outgoing: "Исходящие",
    missed: "Пропущенные",
    completed: "Выполненные",
    ringing: "Звонит",
    busy: "Занято",
    search: "Телефон или контакт...",
    dateFrom: "От",
    dateTo: "До",
    noResults: "Звонки не найдены",
    emptyHint: "Первые звонки появятся здесь",
    deleteSelected: "Удалить выбранные",
    selectAll: "Выбрать все",
    deselectAll: "Снять выбор",
    deleteConfirm: "Удалить {n} выбранных звонка?",
    deleted: "Удалено",
    loadError: "Ошибка загрузки",
    thDate: "Дата / время",
    thDirection: "Направление",
    thPhone: "Телефон",
    thContact: "Контакт",
    thDuration: "Длительность",
    thStatus: "Статус",
    thRecord: "Запись",
    thExt: "Номер",
    statsTotal: "Всего",
    statsMissed: "Пропущено",
    statsDuration: "Общее время",
    linkContact: "Привязать",
    linked: "Привязан",
    viewContact: "Перейти к контакту",
    analytics: "Аналитика",
    noContact: "Без контакта",
    unknown: "Неизвестно",
  },

  contacts: {
    title: "Контакты",
    reminderOverdue: "Напоминание просрочено",
    newContact: "Новый контакт",
    search: "Имя, телефон, email...",
    noContacts: "Контакты не найдены",
    emptyHint: "Добавьте первый контакт",
    import: "Импорт",
    export: "Экспорт",
    columns: "Столбцы",
    deleteSelected: "Удалить ({n})",
    deleteConfirm: "Удалить {n} выбранных контактов?",
    deleted: "Удалено",
    loadError: "Ошибка загрузки",
    importTitle: "Импорт CSV",
    importHint: "Загрузите CSV файл. Первая строка — названия столбцов.",
    importBtn: "Загрузить",
    importPreview: "Предпросмотр",
    importSave: "Сохранить",
    importCancel: "Отмена",
    importSuccess: "Добавлено {n} контактов",
    importError: "Ошибка импорта",
    exportSuccess: "Экспорт начат",
    selectFile: "Выберите CSV файл",
    mapping: "Сопоставление столбцов",
    analytics: "Аналитика",
    thName: "Имя",
    thPhone: "Телефон",
    thEmail: "Email",
    thSource: "Источник",
    thCreated: "Дата",
    thActions: "Действия",
    filterSource: "По источнику",
    allSources: "Все источники",
    yes: "Да",
    no: "Нет",
    fileAttached: "📎 Файл",
    columnsTitle: "Выбор столбцов",
  },

  contactForm: {
    newTitle: "Новый контакт",
    editTitle: "Редактировать контакт",
    back: "Назад",
    save: "Сохранить",
    saving: "Сохраняется...",
    delete: "Удалить",
    deleteConfirm: "Удалить контакт?",
    deleted: "Удалено",
    saved: "Сохранено",
    created: "Создано",
    loadError: "Ошибка загрузки",
    tabGeneral: "Основное",
    tabActivity: "История активности",
    tabDeals: "Сделки",
    name: "Имя *",
    namePlaceholder: "Полное имя...",
    nameRequired: "Имя обязательно",
    phone: "Телефон",
    phonePlaceholder: "+998 XX XXX XX XX",
    email: "Email",
    emailPlaceholder: "example@mail.com",
    source: "Источник",
    sourcePlaceholder: "Telegram, сайт...",
    notes: "Заметки",
    notesPlaceholder: "Заметки...",
    activityEmpty: "Активности нет",
    activityCall: "Звонок",
    activityNote: "Заметка",
    dealsEmpty: "Сделок нет",
    dealAdd: "Добавить сделку",
    error: "Произошла ошибка",
    cancel: "Отмена",
    blocked: "Заблокирован",
    reminder: "Напоминание",
    reminderOverdue: "Напоминание просрочено",
    block: "Заблокировать",
    unblock: "Разблокировать",
    tabFiles: "Файлы",
    tabSettings: "Настройки",
    activitySub: "Заметки, звонки и изменения",
    activityHint: "Сохраните контакт, чтобы добавлять записи",
    activityEmptyHint: "Напишите первую заметку",
  },

  inbox: {
    title: "Inbox",
    search: "Поиск...",
    tabUnanswered: "Без ответа",
    tabAccepted: "Принятые",
    tabClosed: "Закрытые",
    noUnanswered: "Неотвеченных сообщений нет",
    noUnansweredHint: "Новые сообщения появятся здесь",
    noClosed: "Закрытых чатов нет",
    noClosedHint: "Закрытые диалоги появятся здесь",
    noAccepted: "Принятых чатов нет",
    noConvsTotal: "Диалогов нет",
    selectConv: "Выберите диалог",
    selectConvHint: "Выберите диалог из списка слева",
    convCount: "{n} диалогов",
    sendPlaceholder: "Написать сообщение...",
    emailPlaceholder: "Написать email ответ...",
    notePlaceholder: "Написать внутреннюю заметку...",
    noteMode: "Режим внутренней заметки — видно только команде",
    deleteConv: "Удалить диалог",
    deleteMsg: "Удалить сообщение",
    markAnswered: "Отметить как отвеченное",
    markUnanswered: "Отметить как неотвеченное",
    closeConv: "Закрыть диалог",
    openConv: "Переоткрыть диалог",
    reassign: "Назначить",
    reassignTitle: "Назначить сотруднику",
    reassignNone: "Без назначения",
    labelTitle: "Метка",
    addLabel: "Добавить метку...",
    convInfo: "Информация",
    goToContact: "Перейти к контакту",
    createContact: "Создать контакт",
    loadError: "Ошибка загрузки",
    sendError: "Ошибка отправки",
    deleteError: "Ошибка удаления",
    analytics: "Аналитика",
    back: "Назад",
    noSubject: "(Без темы)",
    from: "От:",
    to: "Кому:",
    noAcceptedHint: "Принятые чаты появятся здесь",
    delete: "Удалить",
    msgNotFound: "Сообщение не найдено",
    noMsgs: "Нет сообщений",
    captionPlaceholder: "Добавить подпись (необязательно)...",
    allConvs: "Все разговоры",
    assignedAgent: "Ответственный",
    linkedContact: "Связанный контакт",
    contactName: "Имя *",
    cancel: "Отмена",
    save: "Сохранить",
    noData: "Нет данных",
  },

  dashboardHome: {
    dateLocale: "ru-RU",
    loadError: "Не удалось загрузить данные", retry: "Повторить",
    overdueLabel: "Просроченные", overdueSubAlert: "Требует немедленного внимания", overdueSubOk: "Всё в срок",
    completedLabel: "Выполнено", completedSub: "На последнем этапе",
    activeLabel: "Активные задачи", activeSub: "Требуют выполнения",
    unassignedLabel: "Без ответственного", unassignedSubNoLeads: "Неразмеченные лиды",
    goalsTitle: "Цели", gaugeSum: "Сумма", gaugeDealCount: "Кол-во сделок",
    byEmployee: "По сотрудникам", donutSum: "Сумма", donutCount: "Кол-во",
    byManager: "По менеджерам", dealsCountLabel: "Сделки", sumLabel: "Сумма",
    dealSources: "Источники сделок", other: "Другое", total: "Всего", unit: "шт",
  },

  funnel: {
    journeyAnalytics: "Путь лидов",
    newDeal: "Новая сделка",
    addQuick: "Быстро добавить",
    dealSearch: "Сделка, контакт или номер...",
    sortLabel: 'Сортировка',
    sortManual: 'Обычный (порядок вручную)',
    sortCreatedAsc: 'Старые - новые (по дате создания)',
    sortCreatedDesc: 'Новые - старые (по дате создания)',
    sortUpdatedAsc: 'Старые - новые (по изменению статуса)',
    sortUpdatedDesc: 'Новые - старые (по изменению статуса)',
    sortTitleAsc: 'А - Я',
    sortTitleDesc: 'Я - А',
    dateFrom: 'Дата создания — от',
    dateTo: 'Дата создания — до',
    showClosed: 'Закрытые',
    bulkSelectTitle: 'Массовый выбор',
    select: 'Выбрать',
    selectCancel: 'Отменить',
    archiveBtn: 'Архив',
    statsBtn: 'Статистика',
    noDeals: "Сделок нет",
    totalDeals: "сделок",
    totalValue: "общая сумма",
    loadError: "Ошибка загрузки",
    deleteConfirm: "Удалить сделку?",
    deleted: "Удалено",
    edit: "Редактировать",
    newLead: "Новый лид",
    leadNameLabel: "Имя клиента *",
    contactOpt: "Контакт (необязательно)",
    noContact: "— Без контакта",
    createContact: "+ Создать контакт",
    contactNamePh: "Имя *",
    contactPhonePh: "Телефон",
    contactEmailPh: "Email",
    contactCreated: "Контакт создан",
    contactExists: "Такой контакт уже существует",
    responsibleLabel: "Ответственный",
    unassigned: "— Не назначен",
    notesPlaceholder: "Дополнительная информация...",
    addBtn: "Добавить",
    titleRequired: "Название обязательно",
    searchPlaceholder: "Поиск...",
    noFunnel: "Воронка не найдена",
    stagePlaceholder: "Название этапа...",
    moveTitle: "Сумма сделки",
    moveHint: "Введите сумму (необязательно)",
    moveSave: "Переместить",
    moveCancel: "Отмена",
    export: "Экспорт",
    import: "Импорт",
    exportDone: "Excel загружен",
    exportError: "Ошибка экспорта",
    importTitle: "Импорт Excel",
    importDone: "Импорт завершён!",
    importCreated: "лидов добавлено",
    importSkipped: "пропущено",
    importFormat: "Столбцы Excel (.xlsx):",
    importHint: "Первая строка — названия столбцов. Обязателен только столбец «Sarlavha».",
    downloadTemplate: "Скачать шаблон",
    templateError: "Не удалось скачать шаблон",
    importBtn: "Импортировать",
    importError: "Ошибка импорта",
    onlyXlsx: "Принимается только файл .xlsx",
    dropXlsx: "Перетащите файл Excel (.xlsx) сюда",
    orClick: "или нажмите и выберите",
    clear: "Очистить",
    cancel: "Отмена",
    close: "Закрыть",
  },

  deals: {
    back: "Назад",
    newDeal: "Новая сделка",
    editDeal: "Редактировать сделку",
    save: "Сохранить",
    cancel: "Отмена",
    delete: "Удалить",
    deleteConfirm: "Удалить сделку?",
    deleted: "Удалено",
    saved: "Сохранено",
    created: "Создано",
    loadError: "Ошибка загрузки",
    titleLabel: "Заголовок *",
    titlePlaceholder: "Название сделки...",
    titleRequired: "Заголовок обязателен",
    contact: "Контакт",
    value: "Сумма",
    currency: "Валюта",
    stage: "Этап",
    moveToFunnel: "Перенести в другую воронку",
    moveFunnelLabel: "Воронка",
    moveFunnelPlaceholder: "Выберите воронку...",
    moveStagePlaceholder: "Выберите этап...",
    moveReasonLabel: "Причина (необязательно)",
    moveReasonPlaceholder: "Почему лид переносится в другую воронку...",
    moveSubmit: "Перенести",
    moveSuccess: "Перенесено в другую воронку",
    assignee: "Ответственный",
    dueDate: "Срок",
    notes: "Заметка",
    notesPlaceholder: "Заметка...",
    wonTitle: "Сделка выиграна",
    lostTitle: "Сделка проиграна",
    wonReason: "Причина или комментарий (необязательно)",
    lostReason: "Причина проигрыша (необязательно)",
    reasonPlaceholder: "Причина...",
    confirm: "Подтвердить",
    activitySub: "Заметки и изменения",
    notePlaceholder: "Напишите заметку...",
    activityEmpty: "Нет активности",
    activityHint: "Напишите первую заметку",
    noteTab: "Заметка",
    communicationTab: "Контакт",
    contactTypeCall: "Звонок",
    contactTypeMessage: "Сообщение",
    contactTypeMeeting: "Встреча",
    durationLabel: "мин",
    outcomeInterested: "Заинтересован",
    outcomeThinking: "Думает",
    outcomeDeclined: "Отказ",
    outcomeNoAnswer: "Недозвон",
    outcomeOther: "Другое",
  },

  inboxAnalytics: {
    title: "Аналитика Inbox",
    back: "Inbox",
    tabGeneral: "Общее",
    tabAgents: "Сотрудники",
    preset7d: "7 дней",
    presetMonth: "Этот месяц",
    presetPrevMonth: "Прошлый месяц",
    presetQuarter: "Этот квартал",
    presetCustom: "Произвольный",
    apply: "Применить",
    compare: "Сравнить с прошлым периодом",
    totalConvs: "Всего диалогов",
    unanswered: "Без ответа",
    closed: "Закрыто",
    avgResponse: "Ср. время ответа",
    firstResponse: "Первый ответ",
    resolutionRate: "Решено:",
    prevPeriod: "прошлый период:",
    dailyChart: "Диалоги по дням",
    dayCount: "дней",
    comparison: "Сравнение периодов",
    total: "Всего",
    closedPct: "Закрыто %",
    byChannel: "По каналам",
    agentStats: "Агенты",
    labelStats: "Метки",
    noData: "Данных нет",
    noLabels: "Меток нет",
    agentReport: "Отчёт по сотрудникам",
    exportCsv: "Скачать CSV",
    thAgent: "Сотрудник",
    thTotal: "Диалоги",
    thClosed: "Закрыто",
    thClosedPct: "Закрыто %",
    thAvgResp: "Ср. ответ",
    thCalls: "Звонки",
    loadError: "Не удалось загрузить",
  },

  contactAnalytics: {
    title: "Аналитика контактов",
    back: "Контакты",
    preset30d: "30 дней",
    presetMonth: "Этот месяц",
    preset90d: "90 дней",
    presetCustom: "Произвольный",
    apply: "Применить",
    periodNew: "Новые контакты за период",
    totalAll: "Всего контактов",
    allTime: "За всё время",
    dailyChart: "Новые контакты по дням",
    byChannel: "По каналам (через Inbox)",
    byOperator: "По операторам",
    noPhone: "Телефонов нет",
    noData: "Данных нет",
    loadError: "Не удалось загрузить",
  },

  leadJourney: {
    title: "Путь лидов",
    back: "Воронки",
    preset30d: "30 дней",
    presetMonth: "Этот месяц",
    preset90d: "90 дней",
    presetCustom: "Свой период",
    apply: "Применить",
    contactsWidgetTitle: "Контакты за период",
    uniqueLeadsContacted: "уникальных лидов с контактом",
    byType: "По типу",
    interactedTitle: "Клиенты, с которыми был контакт",
    calledTitle: "Клиенты, с которыми поговорили",
    calledHint: "Дозвонились и пообщались",
    sourceFunnelChange: "Перевод между воронками",
    sourceStageChange: "Перевод между этапами",
    sourceComment: "Комментарий",
    sourceInbox: "Сообщение (Telegram и др.)",
    transitionsWidgetTitle: "Переходы между воронками",
    transitionsEmpty: "За этот период переходов не было",
    snapshotWidgetTitle: "Текущий срез — по воронкам/этапам",
    loadError: "Не удалось загрузить",
  },

  bottomNav: {
    dashboard: "Главная",
    contacts: "Контакты",
    tasks: "Задачи",
    inbox: "Inbox",
    calls: "Звонки",
    reviews: "Отзывы",
    funnels: "Воронки",
  },
};
